var App = App || {};

const MY_DIRECT_ACTION = 1;
const MY_INDIRECT_ACTION = 2;
const FROM_WEBSOCKET = 3;
const FROM_WEBSOCKET_BATCH = 5;
const FROM_OTHER_TAB = 4;

App.object_state = {

	FROM_WEBSOCKET: FROM_WEBSOCKET,

	available: true,
	active_tab: '',
	/** @type Locale */
	locale: {}, // from template
	seen: 0,

	update: function(obj_type, obj_id, obj_data, event_source, event_id, dt) {
		obj_id = parseInt(obj_id);
		if (event_id) {
			if (event_id <= this.seen) return;
			this.seen = event_id;
		}
		if (event_source !== FROM_OTHER_TAB && event_source !== FROM_WEBSOCKET_BATCH) {
			App.core.send_message_to_other_tabs({
				command: 'object_state',
				data: {obj_type, obj_id, obj_data, event_id, dt}
			});
		}
		App.object_state.active_tab = event_source === MY_DIRECT_ACTION;
		App.object_state.event_source = event_source;
		App.object_state.event_dt = dt;

		if (!App.object_state.available) return false;
		// console.log("%c" + obj_type + ' #' + obj_id + " state update", "color: white; background:teal; padding:2px;");
		// console.log(obj_data);
		for (let field_type in obj_data) {
			if (App.object_state[obj_type] && field_type in App.object_state[obj_type]) {
				try {
					App.object_state[obj_type][field_type](obj_id, structuredClone(obj_data[field_type]));
				} catch (e) {
					App.core.error('obj_state.update', e, { obj_type, field_type });
				}
			}
		}
		App.bus.state.emit(obj_type, { id: obj_id, data: structuredClone(obj_data) }, {
			active_tab: App.object_state.active_tab,
			source: event_source,
			event_dt: dt
		});
		Object.keys(obj_data).forEach(field => {
			App.bus.state.emit(obj_type+'_'+field, { id: obj_id, data: structuredClone(obj_data[field]) }, {
				active_tab: App.object_state.active_tab,
				source: event_source,
				event_dt: dt
			});
		});
		App.core.json = null;
	},

	on_too_many_updates: function(primary) {
		if (primary) {
			App.core.send_message_to_other_tabs({ command: 'object_state_too_many' });
			App.task_db.invalidate();
		}
		App.controls.page_reloader.too_many();
	},

	on_sync_start: function(primary) {
		if (primary) App.core.send_message_to_other_tabs({ command: 'object_state_sync_start' });
		App.object_state.fallback.set_timeout();
	},

	on_sync_end: function(max_id, primary) {
		if (primary) App.core.send_message_to_other_tabs({ command: 'object_state_sync_end', data: { max_id: max_id } });

		App.object_state.seen = max_id;
		App.object_state.fallback.set_timeout();
	},

	fallback: {
		period_in_sec: 60,
		timeout: null,
		set_timeout: function() {
			if (this.timeout) clearTimeout(this.timeout);
			this.timeout = setTimeout(this.load, 1000*this.period_in_sec + 500*Math.random()); // only one random tab should process this
		},
		clear_timeout: function() {
			if (this.timeout) clearTimeout(this.timeout);
			this.timeout = null;
		},
		load: function(force) {
			App.object_state.on_sync_start(true);

			if (!App.me.id || !App.object_state.seen || (App.core.websocket.ready && force !== true)) return false;

			$.ajax({
				url: App.helper.endpoint.primary() + '?' + App.actions.get('object_state_log:show') + '&id=' + App.object_state.seen,
				dataType: 'json',
				success: function (resp) {
					if (resp.websocket !== App.core.websocket.host) {
						App.core.websocket.host = resp.websocket;
						App.core.websocket.postMessage({
							action: 'config',
							host: App.core.websocket.host,
						});
					}
					if (resp.too_many) {
						App.object_state.on_too_many_updates(true);
					} else if (resp.data) {
						resp.data.forEach(function(data) {
							App.object_state.update(data.obj_type, data.obj_id, data.obj_data, FROM_WEBSOCKET, data.event_id);
							App.core.send_message_to_other_tabs({ command: 'object_state', data: data });
						})
					}

					App.object_state.on_sync_end(resp.max_id, true);
				}
			})
		}
	},

	helper: {

		common_task_update: function(id, get_updated_data, need_dom_update, skip_subtasks_update = false) {
			App.bus.state.emit('task_updated', {
				id_task: id,
				get_updated_data: get_updated_data,
				need_dom_update: need_dom_update
			}, {
				source: App.object_state.event_source,
				event_dt: App.object_state.event_dt
			});

			// Subtasks storage // TODO: move to subtasks.js onBoot bus.state.on('task_updated', ....
			if (!skip_subtasks_update && App.subtasks.data.exists('task', id))	{
				if (need_dom_update) {
					App.helper.object.append(App.subtasks.data.task[id], get_updated_data(App.subtasks.data.task[id]));
					App.subtasks.dom.invalidate(id);
				} else App.subtasks.data.update('task', id, get_updated_data(App.subtasks.data.task[id]));
			}
		},

		common_task_delete: function(id) {
			// Subtasks storage // TODO: move to subtasks.js onBoot bus.state.on('task', ....
			if (App.subtasks.data.exists('task', id)) App.subtasks.data.delete('task', id);
		},

		common_task_add: function(id, data) {
			// Subtasks storage // TODO: move to subtasks.js onBoot bus.state.on('task', ....
			if (App.object_state.task.helper_match_viewing_tasks(data)) {
				for (let id_other in App.subtasks.data.task) {
					if (id_other != id && App.subtasks.data.task[id_other]['id_parent'] === data['id_parent'] && App.subtasks.data.task[id_other]['manual_order'] >= data.manual_order) App.subtasks.data.task[id_other]['manual_order']++;
				}
				App.subtasks.data.add('task', id, data);
			}
		},

		timeout: null,
		ids_status_reload: [],
		ids_obj_updated: [],

		kanban_cards_reload: function() {
			if (App.page.where() != 'projects_kanban') return;
			let action = 'projects_kanban_reload:do';
			$.ajax({
				url: App.helper.url.add_query(App.page.url.base, App.actions.get(action)) + '&ids=' + App.object_state.helper.ids_status_reload.join(',') + '&ids_real=' + App.object_state.helper.ids_obj_updated.join(','),
				type: 'GET',
				dataType: 'html',
				timeout: 5000,
				success: App.page.update_cards_html
			});
			App.object_state.helper.ids_status_reload = [];
			App.object_state.helper.ids_obj_updated = [];
		},
		queue_kanban_cards_reload: function(ids_card, id) {
			for (let i in ids_card) if (!App.object_state.helper.ids_status_reload.includes(ids_card[i])) App.object_state.helper.ids_status_reload.push(ids_card[i]);
			if (!App.object_state.helper.ids_obj_updated.includes(id)) App.object_state.helper.ids_obj_updated.push(id);
			if (App.object_state.helper.timeout) clearTimeout(App.object_state.helper.timeout);
			App.object_state.helper.timeout = setTimeout(App.object_state.helper.kanban_cards_reload, 50);
		},

		todo_update: function(id_task, new_todos, old_todos) {
			new_todos = new_todos ? new_todos.split('/').map(Number) : [0,0];
			old_todos = old_todos ? old_todos.split('/').map(Number) : [0,0];
			App.components.task_todos?.list_by_object[id_task]?.forEach((el) => {
				el.tpl_data.cnt_done += new_todos[0] - old_todos[0];
				el.tpl_data.cnt += new_todos[1] - old_todos[1];
				App.components.task_todos.redraw(el);
			});
		},

		contacts_update: function(id_task, contacts) {
			App.components.task_contacts?.list_by_object[id_task]?.forEach((el) => {
				el.tpl_data = ids_contact;
				App.components.task_todos.redraw(el);
			});
			let ids_contact = Object.keys(contacts);

			let get_updated_data = function(orig_data) {
				return {
					class: orig_data.class.replace(App.components.task_contacts.regex_remove_class, '')
						+ (ids_contact.length ? ' c2 c'+ ids_contact.join(' c') : '')
				}
			}

			App.object_state.helper.common_task_update(id_task, get_updated_data);

			switch (App.page.where()) {
				case 'tasks':
				case 'tasks_grid':
				case 'users_tasks':
				case 'kanban':
				case 'kanban_days':
				case 'gantt':
					if (App.page.data?.exists('task', id_task)) App.page.data.update('task', id_task, get_updated_data(App.page.data.task[id_task]));
					break;
			}
		}
	},

	queue_update: {
		data: [],
		run: function() {
			if (this.data.length == 0) return false;
			this.data.forEach(function(data) {
				App.object_state.update(data.obj_type, data.obj_id, data.obj_data, data.event_source, data.event_id, data.dt);
			});
			this.data = [];
		}
	},

	onBoot: function () {
		App.bus.ws
			.on('object_state', (data) => {
				data.event_source = FROM_WEBSOCKET;
				App.object_state.queue_update.data.push(data);
				App.core.call_once(() => App.object_state.queue_update.run(), 0.05);
			})
			.on('object_state_batch', (batch_data) => {
				batch_data.forEach(data => {
					data.event_source = FROM_WEBSOCKET_BATCH;
					App.object_state.queue_update.data.push(data);
				});
				App.object_state.queue_update.run()
				App.core.send_message_to_other_tabs({
					command: 'object_state_batch',
					data: batch_data
				});
			})
			.on('offline', function () {
				App.object_state.fallback.set_timeout();
			})
			.on('online', function () {
				App.object_state.fallback.load(true); // fetch lost events
			});

		App.bus.other_tab
			.on('object_state', (data) => {
				data.event_source = FROM_OTHER_TAB;
				App.object_state.queue_update.data.push(data);
				App.core.call_once(() => App.object_state.queue_update.run(), 0.05);
			})
			.on('object_state_batch', (batch_data) => {
				batch_data.forEach(data => {
					data.event_source = FROM_OTHER_TAB;
					App.object_state.queue_update.data.push(data);
				});
				App.object_state.queue_update.run()
			})
			.on('object_state_sync_start', () => App.object_state.on_sync_start())
			.on('object_state_too_many', () => App.object_state.on_too_many_updates())
			.on('object_state_sync_end', (data) => App.object_state.on_sync_end(data.max_id));
	},
	onLogin: function () {
		App.object_state.fallback.set_timeout();
	},
	onLogout: function () {
		App.object_state.fallback.clear_timeout();
	}
};

;App.object_state.account = {

	name: function(id, data) {
		let o = $('#sidebar .sidebar__head .account .in')
			.add($('#adminMenu .sidebar__head .path .in'))
			.add($('#sidebarAccMenu .acc_name'))
			.add($('#headerMobile .account .in'))
			.add($('.menu__item[data-cmd=\"workspace_switch/'+id+'\"] .in > div:first-child'))
		;

		o.text(data.name);

		$('#sidebarProfileMenu .account-switch').attr('text', data.name);
	},

	logo: function(id, data) {

		// set/reset logos data
		if (data.dark_logo !== undefined) App.logos.dark = data.dark_logo;
		if (data.light_logo !== undefined) App.logos.light = data.light_logo;

		// redraw logo components
		$('ws-app-logo').each((_, el) => el.render());
	},

	update: function(id, data) {

		const changed_account_subpages = {
			plan: Boolean(data.payment),
			apps: Boolean(data.integrations),
			security: Boolean(data.auth || data.ftp || data.backup),
			addons: Boolean(data.time || data.timer || data.money || data.support),
			settings: Boolean(data.datetime || data.work_time || data.holidays || data.profile),
			api: Boolean(data.api),
			members: Boolean(data.user_options),
		};

		switch (App.current_page.page) {
			case 'account':
				if (changed_account_subpages[App.current_page.subpage]) {
					if (App.current_page.subpage === 'plan') { // only promo_sync gate updates
						App.core.call_once(function() {
							App.core.reload();
						});
					} else {
						App.core.next_force_goto = true;
						if (App.object_state.active_tab !== true) this.helper_request_account_reload(true);
					}
				}
				break;
			default:
				if (data.money || data.time) {
					App.task_view_cache.invalidate_all();
					App.task_create_cache.invalidate_all();
				}
				if (data.money || data.time || data.timer || data.user_options) this.helper_request_account_reload(true);
		}

		if (data.profile) {
			if (data.profile.name) this.name(id, data.profile);
			if (data.profile.dark_logo !== undefined || data.profile.light_logo !== undefined) this.logo(id, data.profile);
		}

		if (data.state) this.state(id, data.state);
	},

	state: function (id, hash_state) {
		App.account.hash_state = hash_state;
		App.controls.page_reloader.state_changed();
	},

	helper_request_account_reload: App.helper.debounce(function(force) {
		App.controls.page_reloader.account_changed(force);
	}, 30000),
}

;App.object_state.comment = {

	add: function(id, data) {
		if (data.filter == 'mention') App.mymenu.data['event_hot'] = 1;
		// TODO запакувати в App.components.update
		let last_update_data = {};
		App.components.task_unseen.list_by_object[data.id_task]?.forEach((el) => {
			el.tpl_data.id_max = id;
			el.tpl_data.dt_max = data.dt;
			el.tpl_data.user_last_name = App.helper.team(data.id_user, 'name') || '';
			el.tpl_data.has_mention = el.tpl_data.has_mention || data.filter === 'mention';
			if (data.filter === 'mention') {
				el.tpl_data.id_user_mention = data.id_user;
			}
			if (!el.tpl_data.subs || data.id_user === App.me.id) {
				el.tpl_data.id_seen = id;
			} else if (!(App.task_view.is_shown() && App.task_view.id === data.id_task)) {
				el.tpl_data.count++;
			}
			last_update_data = el.tpl_data;
			App.components.task_unseen.redraw(el);
		});
		App.components.emit_update(App.components.task_unseen, data.id_task, last_update_data);

		if (data.id_user !== App.me.id && !App.comments.helper_i_see_task(data.id_task)) {
			let get_updated_data = function (orig_data) {
				let ids_user = App.object_state.task.helper_class_to_subscribers(orig_data.class);
				return {
					class: orig_data.class.match(App.components.task_unseen.regex_remove_class) || !ids_user.includes(App.me.id) ? orig_data.class : orig_data.class + ' p' + App.components.task_unseen.list_task_classes['new_comments']
				}
			}

			App.object_state.helper.common_task_update(id, get_updated_data);

			switch (App.page.where()) {
				case 'tasks':
				case 'tasks_grid':
				case 'users_tasks':
				case 'kanban':
				case 'kanban_days':
				case 'gantt':
					if (App.page.data?.exists('task', id)) {
						App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
					}
					break;
			}
		}
		let cache_data = App.task_view_cache.pop_by_id(data.id_task);
		if (cache_data) {
			if (!App.core.is_active() && data.id_user != App.me.id) App.mymenu.update_page_title_alert();
			if (data.id_delete && data.id_user === App.me.id) { // replace delayed publication comment
				App.comments.delete_item(data.id_delete, 'comment', data.id_task);
			}
			App.comments.add_item(id, 'comment', {
				id: id,
				type: 'comment',
				dateadd: parseInt(data.dt),
				id_user: data.id_user,
				filter: data.filter
			}, data.id_task);
		}
		App.controls.typing.delete(data.id_task, data.id_user);
		App.chat_view.on_comment_add(id, data);
		App.chat_view.update_counter();
		if (data.todos) App.object_state.helper.todo_update(data.id_task, data.todos, null);
		if (data.contacts) App.object_state.helper.contacts_update(data.id_task, data.contacts);
	},

	edit: function(id, data) {
		if (data.filter == 'mention') App.mymenu.data['event_hot'] = 1;
		// TODO запакувати в App.components.update
		let last_update_data = {};
		App.components.task_unseen.list_by_object[data.id_task]?.forEach((el) => {
			if (id > el.tpl_data.id_max) {
				el.tpl_data.id_max = id;
				el.tpl_data.dt_max = data.dt;
				el.tpl_data.user_last_name = App.helper.team(data.id_user, 'name') || '';
				el.tpl_data.has_mention = el.tpl_data.has_mention || data.filter.includes('mention');
				if (!el.tpl_data.subs || data.id_user === App.me.id) {
					el.tpl_data.id_seen = id;
				} else if (!(App.task_view.is_shown() && App.task_view.id === data.id_task)) {
					el.tpl_data.count++;
				}
				last_update_data = el.tpl_data;
				App.components.task_unseen.redraw(el);
			}
		});
		App.components.emit_update(App.components.task_unseen, data.id_task, last_update_data);
		let cache_data = App.task_view_cache.pop_by_id(data.id_task);
		if (cache_data) {
			if (App.comments.exists_data(id, 'comment', data.id_task)) {
				App.comments.update_data(id, 'comment', { filter: data.filter }, data.id_task);
				App.comments.dom.invalidate(id, 'comment', data.id_task);
			} else {
				App.comments.add_item(id, 'comment', {
					id: id,
					type: 'comment',
					dateadd: data.dt,
					id_user: data.id_user,
					filter: data.filter
				}, data.id_task, true);
			}
		}
		App.chat_view.on_comment_edit(id, data);
		if (data.todos) App.object_state.helper.todo_update(data.id_task, data.todos[0], data.todos[1]);
		if (data.contacts) App.object_state.helper.contacts_update(data.id_task, data.contacts);
	},

	delete: function(id, data) {
		if (data.id_user !== App.me.id) {
			// TODO запакувати в App.components.update
			let last_update_data = {};
			App.components.task_unseen.list_by_object[data.id_task]?.forEach((el) => {
				if (id > el.tpl_data.id_seen) {

					if (el.tpl_data.has_mention && data.ids_mention && data.ids_mention.includes(App.me.id)) {
						el.tpl_data.has_mention = false;
					}

					if (el.tpl_data.count) el.tpl_data.count--;
					if (el.tpl_data.count === 0) el.tpl_data.has_mention = false;

					last_update_data = el.tpl_data;

					App.components.task_unseen.redraw(el);
				}
			});
			App.components.emit_update(App.components.task_unseen, data.id_task, last_update_data);
		}
		let cache_data = App.task_view_cache.pop_by_id(data.id_task);
		if (cache_data) {
			App.comments.delete_item(id, 'comment', data.id_task);
		}
		App.chat_view.on_comment_delete(id, data);
		App.chat_view.update_counter();
		if (App.object_state.active_tab) {
			App.core.call_once(function() {
				App.comments.mass.update_menu();
				App.mass.action_done();
			});
		}
		if (data.todos) App.object_state.helper.todo_update(data.id_task, null, data.todos);
		if (data.contacts) App.object_state.helper.contacts_update(data.id_task, data.contacts);
	},

	like: function(id, data) {
		App.components.task_reactions?.list_by_object[data.id_task]?.forEach((el) => {
			if (el.tpl_data.id_comment != id) return;
			if (data.remove) {
				if (data.id in el.tpl_data.likes) el.tpl_data.likes[data.id] = el.tpl_data.likes[data.id].filter((i) => i !== data.id_user);
				if (!el.tpl_data.likes[data.id].length) delete(el.tpl_data.likes[data.id]);
			} else {
				if (!(data.id in el.tpl_data.likes)) el.tpl_data.likes[data.id] = [];
				el.tpl_data.likes[data.id].push(data.id_user);
			}
			App.components.task_reactions.redraw(el);
		});
	},
}

;App.object_state.costs = {

	add: function(id, data) {
		// TODO: write logics
	},

	update: function(id, data) {
		// TODO: write logics
	},

	date: function(id, data) {
		// debugger;
		let o, alert;

		let get_updated_data = function(orig_data) {
			let item_data_diff = {}
			return item_data_diff;
		}

		if (App.page.where() == 'tasks_grid' && App.page.report.type === 'costs') {
			let match = data.dateadd >= App.time_interval.min && data.dateadd <= App.time_interval.max;
			let match_before = data.before.dateadd >= App.time_interval.min && data.before.dateadd <= App.time_interval.max;
			if (match && !match_before) {
				App.page.report.update_item(id, data, 'plus');
			} else if (!match && match_before) {
				App.page.report.update_item(id, data, 'minus');
			}
			if (id in App.page.data.task) {
				App.page.draw_item_costs(id);
				App.core.call_queue.add('update_progress_bars', App.page.update_progress_bars, App.page, null, 0.01);
			}
		}

		switch (App.page.where()) {

			case 'report':
				alert = '';
				if (App.page.time_interval.min && data.dateadd < App.page.time_interval.min || App.page.time_interval.max && data.dateadd > App.page.time_interval.max) {
					alert = '<ws-icon name="exclam_triangle-fill" data-title="' + App.object_state.locale['interval_error'] + '""></ws-icon>';
				}
				o = $('#obj-cost' + id);
				o.find('.td_done_date .in').html('<span class="flex_content">' + data.html + '</span>' + alert);
				break;
		}
	},

	user: function(id, data) {
		let o;

		let id_user = data.id_user_from;

		if (App.page.where() == 'tasks_grid' && App.page.report.type === 'costs') {
			let match = data.dateadd >= App.time_interval.min && data.dateadd <= App.time_interval.max;
			if (match) {
				App.page.report.update_item(id, data, 'plus');
				const data_before = App.helper.object.clone(data, {id_user_from: data.before.id_user_from});
				App.page.report.update_item(id, data_before, 'minus');
			}
			if (id in App.page.data.task) {
				App.page.draw_item_costs(id);
				App.core.call_queue.add('update_progress_bars', App.page.update_progress_bars, App.page, null, 0.01);
			}
		}

		switch (App.page.where()) {

			case 'report':
				let alert = '';
				if (
					App.filter.data['group'] && App.filter.data['group'] != App.team[id_user].id_group
					|| App.filter.data['group_sub'] && App.filter.data['group'] != App.team[id_user].id_group_sub
					|| App.filter.data['user'] && App.filter.data['user'] != id_user
				) {
					alert = '<ws-icon name="exclam_triangle-fill" data-title="' + App.object_state.locale['filter_error'] + '""></ws-icon>';
				}
				let html = App.helper.template.fill('common_user', {
					name: App.team[id_user].name,
					avatar: App.team[id_user].avatar
				});
				o = $('#obj-cost' + id);
				o.find('.td_assignee .in').html(html + alert);
				break;
		}
	}
}

;App.object_state.event = {
	add: function (id, data) {
		if (data.type) {
			App.mymenu.increase_event_cnt(data.type, data.id_task, App.object_state.event_source === FROM_WEBSOCKET);
		}
	},
	seen: function() {
		App.mymenu.mark_events_as_seen();
		if (App.object_state.active_tab) App.core.send_message_to_other_devices({
			command: 'object_state',
			data: {
				obj_type: 'event',
				obj_id: 0,
				obj_data: {seen: true}
			},
		}, 'events_seen');
	}
}
;App.object_state.folder = {
	order: function (id, data) {
		App.sidebar.need_reload('projects');
	},

	name: function(id, data) {
		App.sidebar.obj_projects?.find('#obj-folder' + id).find('.sidebar__projects__group__title > .flex_content').each(function() {
			let o = $(this).find('.cnt').detach();
			$(this).text(data.name).append(o);
		});
	},

	color: function(id, data) {
		const _setColor = (el) => {
			const replaceClass = el.attr('class').replace(/(\s|\b)proj_folder_color\d+\b/g, '') + ' proj_folder_color' + data.value;
			el.attr('class', replaceClass.trim());
		};

		App.sidebar.obj_projects?.find('#obj-folder' + id).each(function() {
			_setColor($(this));
		});
		$('.dataTable__group[data-group-id="' + id + '"] span.space ws-icon, .dataTable__subgroup[data-group-sub-id="' + id + '"] span.space ws-icon').each(function() {
			_setColor($(this));
		});
	},

	add: function(id, data) {
		if (data.reload) App.sidebar.need_reload('projects');
	},

	delete: function(id, data) {
		if (data.reload) App.sidebar.need_reload('projects');
	},
}

;App.object_state.log = {

	add: function(id, data) {
		let cache_data = App.task_view_cache.pop_by_id(data.id_task);
		if (cache_data) {
			if (!App.core.is_active() && data.id_user != App.me.id) App.mymenu.update_page_title_alert();
			App.comments.add_item(id, 'log', {
				id: id,
				type: 'log',
				dateadd: data.dt,
				id_user: data.id_user,
			}, data.id_task);
		}
	},

	edit: function(id, data) {
		let cache_data = App.task_view_cache.pop_by_id(data.id_task);
		if (cache_data) {
			App.comments.dom.invalidate(id, 'log', data.id_task);
		}
	},

	delete: function(id, data) {
		let cache_data = App.task_view_cache.pop_by_id(data.id_task);
		if (cache_data) {
			App.comments.delete_item(id, 'log', data.id_task);
		}
		if (App.object_state.active_tab) {
			App.core.call_once(function() {
				App.comments.mass.update_menu();
				App.mass.action_done();
			});
		}
	},
}
;App.object_state.project = {

	add: function(id, data) {
		if (App.object_state.active_tab && !(App.page.where() === 'onboarding' && Object.keys(App.projects).length <= 1)) {
			App.core.goto(App.helper.url.project(id));
		} else if (App.object_state.active_tab) {
			App.page.helper.action_event('project_add', id, data);
		}

		if ($('body').attr('data-project') === String(id)) {
			App.controls.page_reloader.ask_reload();
		}
	},

	import: function(id, data) {
		if (data.task_cnt || data.file_cnt) {
			if ($('body').attr('data-project') === String(id)) {
				App.controls.page_reloader.ask_reload();
			}
		}
	},

	mass: function(id, data) {
		if (String(data.type).startsWith('task')) {
			if ($('body').attr('data-project') === String(id)) {
				App.controls.page_reloader.ask_reload();
			}
		}
	},

	// TODO: need make normal ava (fix bug)
	user_to: function(id, data) {

		let component_data = {};
		['id', 'avatar', 'name', 'icon'].forEach((i) => component_data[i] = data[i]);
		App.components.project_assignee.list_by_object[id]?.forEach((el) => App.components.project_assignee.redraw(el, component_data));

		// if (!data.id) data.avatar = '<ws-icon name="person" class="border_dashed"</ws-icon>'; some fallback may be needed

		let permission_changed = App.me.id === data.id || App.me.id === data.before.id;

		if (App.page.data?.exists('project', id)) App.page.data.update('project', id, { id_user_to: data.id });

		let o;
		switch (App.page.where()) {

			case 'projects':
				o = $('#obj-project' + id);
				o.attr('class', o.attr('class').replace(/ u\d+/g, '') + ' u' + data.id).find('.ava').attr('data-title', data.name + (data.id ? '\n%G' + App.object_state.locale['manager'] + 'G%' : '')).html(data.avatar);
				break;
			case 'projects_kanban':
			case 'projects_grid':
				o = $('#obj-project' + id);
				o.attr('class', o.attr('class').replace(/ u\d+/g, '') + ' u' + data.id).find('.av_pre').attr('data-title', data.name + (data.id ? '\n%G' + App.object_state.locale['manager'] + 'G%' : '')).html(data.avatar);
				break;

			case 'project_dashboard':
				if (App.current_page.project === id) $('.project_users .user_to .ava').html(data.avatar.replace(/av_sm/g, 'av_nm').filter('img').attr('width', 48).attr('height', 48)).next().attr('data-id', data-id).text(data.name);
				break;

			case 'tasks_grid':
				if (permission_changed) {
					if ($('body').attr('data-project') === '0' || $('body').attr('data-project') == id) App.controls.page_reloader.permissions_changed();
				}
				break;
		}

		if (permission_changed) App.task_view_cache.invalidate_by_project(id);
	},

	settings: function (id, data) {
		let changes = data.changes || {};
		let should_invalidate_tasks = changes.assignee_permissions || changes.user_permissions || changes.time_limits;

		if (changes.assignee_permissions && App.page.where() === 'tasks_grid') {
			if (['0', String(id)].includes($('body').attr('data-project'))) App.controls.page_reloader.permissions_changed();
		}

		if (should_invalidate_tasks) App.task_view_cache.invalidate_by_project(id);
		if ('require_fields' in changes) {
			App.menu.invalidate_cache_by_trigger('project');
			App.task_create_cache.invalidate_by_project(id);
			switch (App.page.where()) {
				case 'tasks_grid':
					let o_new = $('.dataTable__item-newTask[data-project='+id+']');
					if (o_new.length) {
						o_new.attr('data-require', changes.require_fields);
						App.task_grid_create.helper_component_requirements();
					}
					break;
				case 'tasks':
				case 'users_tasks':
				case 'kanban':
				case 'kanban_days':
				case 'gantt':
					if (App.current_page.project === id) {
						App.core.call_once(() => App.core.reload());
					}
					break;
			}
		}
	},

	tag: function(id, data) {
		let o;

		data.class = '';
		data.task_class = '';
		data.tags.forEach(function(id_tag) {
			if (id_tag in App.tags) { // Visible for me
				data.class += ' t' + id_tag;
				data.task_class += ' pt' + id_tag;
			}
		});
		App.components.project_tags.list_by_object[id]?.forEach((el) => {
			el.tpl_data.tags = data['tags'];
			App.components.project_tags.redraw(el);
		});

		if (App.page.data?.exists('project', id)) {
			let new_class = App.page.data.get('project', id).class;
			new_class = new_class.replace(App.components.project_tags.regex_remove_class, '') + data.class;
			App.page.data.update('project', id, { class: new_class });
		}

		switch (App.page.where()) {

			case 'projects':
			case 'projects_kanban':
				o = $('#obj-project' + id);
				if (o.length) {
					o.attr('class', o.attr('class').replace(App.components.project_tags.regex_remove_class, '') + data.class);
					App.page.helper_tags_show(o)
				}

				App.core.call_once(function() {
					App.mass.action_done();
					App.page.update_card_positions(true);
				});
				break;
			case 'projects_grid':
				o = $('#obj-project' + id);
				if (o.length) {
					o.attr('class', o.attr('class').replace(App.components.project_tags.regex_remove_class, '') + data.class);
				}
				break;
		}

		/** Update Project related task class **/

		let get_updated_data = function(orig_data) {
			return {
				class: orig_data.class.replace(App.components.task_tags.regex_remove_class, '') + data.task_class
			}
		}

		switch (App.page.where()) {

			case 'tasks':
			case 'users_tasks':
			case 'kanban':
			case 'gantt':
				for (let id_task in App.page.data.task) if (App.page.data.task[id_task].id_project === id)  {
					App.page.data.update('task', id_task, get_updated_data(App.page.data.task[id_task]));
				}
				break;

		}

	},

	folder: function (id, data) {
		if (App.page.data?.exists('project', id)) App.page.data.update('project', id, { id_group: data.id_group });

		App.components.project_folder.list_by_object[id]?.forEach((el) => {
			App.components.project_folder.redraw(el, data);
			$(el).parent('a[data-container=folder][data-group]').attr('data-group', data.id_group)
		});
	},

	status: function(id, data) {
		if (App.page.data?.exists('project', id)) App.page.data.update('project', id, { id_stage: data.id });

		App.components.project_stage.list_by_object[id]?.forEach((el) => {
			el.tpl_data.id = data.id;
			App.components.project_stage.redraw(el);
		});

		/** Update Project related task class **/

		let get_updated_data = function(orig_data) {
			return {
				class: orig_data.class.replace(App.components.task_tags.regex_remove_class, '') + ' pst' + data.id
			}
		}

		switch (App.page.where()) {

			case 'projects_kanban':
				if (App.object_state.active_tab) {
					$('#obj-card' + id).removeClass('listing__card-prohibited');
					App.object_state.helper.queue_kanban_cards_reload([data.id, data.before.id], id);
				} else {
					// App.object_state.project.helper_invalidate_project(id);
				}
				break;

			case 'tasks':
			case 'users_tasks':
			case 'kanban':
			case 'gantt':
				for (let id_task in App.page.data.task) if (App.page.data.task[id_task].id_project === id)  {
					App.page.data.update('task', id_task, get_updated_data(App.page.data.task[id_task]));
				}
				break;

		}
	},

	terms: function(id, data) {
		let o;

		let component_data = {};
		['dateadd', 'datestart', 'dateend', 'time_diff'].forEach((i) => component_data[i] = data.raw_data[i]);
		App.components.project_terms.list_by_object[id]?.forEach((el) => App.components.project_terms.redraw(el, component_data));

		let get_updated_data = function(orig_data) {
			return {
				datestart: data.raw_data.datestart,
				dateend: data.raw_data.dateend,
			}
		}

		if (App.page.data?.exists('project', id)) {
			App.page.data.update('project', id, {
				datestart: data.raw_data.datestart,
				dateend: data.raw_data.dateend,
			});
		}

		switch (App.page.where()) {

			case 'project_dashboard':
				if (App.object_state.active_tab && !$('#obj-project-modal-info' + id).length) App.core.reload();
				break;

			case 'home':
				$('.project_bl_home item[data-project=' + id + '] [data-container=terms]').html(data.label_card);
				break;

			case 'projects':
			case 'projects_kanban':
			case 'projects_grid':
				o = $('#obj-project' + id);
				if (o.length) {
					o.attr('class', o.attr('class').replace(/ ds_\d+/g, '') + ' ds_' + component_data.datestart);
					o.attr('class', o.attr('class').replace(/ de_\d+/g, '') + ' de_' + component_data.dateend);
					o.removeClass('p23 p24').addClass(data.class);
					o.find('[data-container=end_date] *:first-child').html(data.html_list).next().html(data.label_list);
					o.find('[data-container=start_date]').html(data.html_start_list);
				}
				break;

			case 'gantt':
				if (App.page.data?.exists('project', id)) App.page.data.update('project', id, get_updated_data(App.page.data.project[id]));
				break;
		}

		o = $('#obj-project-modal-info' + id);
		if (o.length) {
			o.find('[data-container=end_date] *:first-child').html(data.html_simple).next().html(data.label_details);
			o.find('[data-container=start_date]').html(data.html_start_details);
		}
	},

	name: function(id, data) {
		App.components.update(App.components.project_name, id, data);

		if (id in App.projects) App.projects[id].name = data.name;

		//TODO: perhaps find better way to update project name in the page (only for kanban/users_tasks/kanban_days)
		if (App.page.dom?.project?.[id]) {
			$('.listing__card__group__title[data-project=' + id + ']').replaceWith(App.page.dom.project[id].clone());
			if (App.page.update_project_counters) App.page.update_project_counters();
		}

		if (App.page.update_parent_hints) {
			App.page.update_parent_hints();
		}

		App.task_view.sync_document_title(null, id, data.name);
	},

	topic: function(id, data) {
		let o = $('#obj-project-modal-info' + id);
		let body = $('body');

		if (o.length) o.find('.projectView__group-topic .projectView__group__content').text(data.topic);

		if (body.attr('data-project')) {
			let topic = $('.headerGeneral__content .topic');
			if (data.topic) {
				let marquee_el = topic.find('ws-marquee').get(0);
				if (!marquee_el) {
					marquee_el = document.createElement('ws-marquee');
					marquee_el.setAttribute('behavior', 'bounce');
					marquee_el.setAttribute('trigger', 'auto');
					marquee_el.setAttribute('pause-on-hover', 'true');
				}
				marquee_el.textContent = data.topic;
				if (!topic.get(0).contains(marquee_el)) topic.append(marquee_el);
				topic.find('span').remove();
				topic.removeClass('topic-empty');
			} else {
				let span_el = topic.find('span').get(0);
				if (!span_el) {
					span_el = document.createElement('span');
				}
				span_el.textContent = topic.attr('data-text');
				if (!topic.get(0).contains(span_el)) topic.append(span_el);
				topic.find('ws-marquee').remove();
				topic.addClass('topic-empty');
			}
		}
		switch (body.attr('data-page')) {
			case 'projects_grid':
				o = $('#obj-project' + id);
				if (o.length) {
					o.find('td.td_topic .in .flex_content').text(data.topic);
				}
				break;
		}
	},

	descr: function(id, data) {},

	note: function(id, data) {
		let body = $('body');
		let o;
		switch (body.attr('data-page')) {
			case 'projects_grid':
				o = $('#obj-project' + id);
				if (o.length) {
					o.find('td.project_note .in .flex_content').html(data.note);
				}
				break;
			case 'projects':
				o = $('#obj-project' + id);
				if (o.length) {
					o.find('.listing__item__body-people').toggleClass('has_note', data.note && data.note.length > 0);
					o.find('.note').html('<div>' + data.note + '</div>');
					App.page.update_card_positions();
				}
				break;
		}
	},

	color: function(id, data) {
		let sel = '.proj_color[data-project=' + id + ']', o = $(sel);

		Object.keys(App.mymenu.cache).forEach(function(k) {
			o = o.add(App.mymenu.cache[k].obj_window.find(sel));
		});

		o = o.add(App.task_view_cache.get_all().find(sel));

		o.attr('class', 'proj_color proj_color' + data.value).attr('data-color', data.value);

		if (App.page.data?.exists('project', id)) App.page.data.update('project', id, { id_color: data.value });
		$('#obj-project' + id).attr('class', o.attr('class').replace(/\sc\d+/g, '') + ' c' + data.value);

		App.task_panel.update_symbols();
	},

	emoji: function(id, data) {
		let sel = '.proj_color[data-project=' + id + ']', o = $(sel);

		Object.keys(App.mymenu.cache).forEach(function(k) {
			o = o.add(App.mymenu.cache[k].obj_window.find(sel));
		});

		o = o.add(App.task_view_cache.get_all().find(sel));

		o.each(function() {
			if ($(this).hasClass('proj_color-alt')) {
				$(this).replaceWith(data.value
						? '<ws-icon class="'+$(this).attr('class')+'" data-project="'+id+'"><ws-emoji id="'+data.value+'"></ws-emoji></ws-icon>'
						: '<ws-icon name="project_xl-invert" class="'+$(this).attr('class')+'" data-project="'+id+'"></ws-icon>');
			} else {
				$(this).find('ws-emoji').attr('id', data.value || '');
			}
		});

		App.task_panel.update_symbols();
	},

	limits: function(id, data) {

		let o, alert;

		if (App.page.data?.exists('project', id)) {
			App.page.data.update('project', id, {
				max_time: data.time,
				max_money: data.money,
			});
		}

		switch (App.page.where()) {

			case 'gantt':
				$('#obj-project-right' + id).find('.tml').html(data.label_gantt).toggleClass('tml_act', 1*data.time !== 0);
				break;

			case 'projects':
			case 'projects_kanban':
			case 'projects_grid':
				o = $('#obj-project' + id).find('.progress_block');
				if (o.length) {
					o.each(function(i, el){
						if ($(el).is('[data-max-time]')) $(el).attr('data-max-time', data.time);
						if ($(el).is('[data-max-money]')) $(el).attr('data-max-money', data.money);
					});
					App.page.draw_item_costs(id);
				}
				break;
			case 'project_dashboard':
				App.controls.costs_bars.reload_project(id);
				break;

		}

		o = $('#obj-project-modal-info' + id);
		if (o.length) {
			App.controls.costs_bars.reload_project(id);
		}
	},

	team: function(id, data) {
		let o;
		if (data.delete && data.delete.includes(App.me.id)) {
			if (App.current_page.project === id) {
				App.core.call_once(() => App.core.goto('/'));
			} else if (App.page.where() === 'projects_kanban') {
				App.core.call_once(() => App.core.reload());
			}
		}

		if (App.page.data?.exists('project', id)) {
			let new_class = App.page.data.get('project', id).class;

			if (data.add) data.add.forEach((item) => { new_class+= ' u'+item; });
			if (data.delete) data.delete.forEach((item) => { new_class = new_class.replace('u'+item, ''); });

			App.page.data.update('project', id, { class: new_class.trim() });
		}

		switch (App.page.where()) {
			case 'projects':
				o = $('#obj-project' + id);
				if (o.length) {
					o.find('.users .in').load(App.helper.endpoint.ajax(id) + '?' + App.actions.get('project_list_reload_users_ava:show'));
				}
				break;
			case 'project_dashboard':
				$('.project_users .users').load(App.helper.endpoint.ajax(id) + '?'  + App.actions.get('project_reload_users_ava:show'));
				break;
			case 'projects_kanban':
				o = $('#obj-project' + id);
				if (data.add) {
					data.add.forEach((item) => { o.addClass('u'+item); });
					o.toggleClass('w_me', data.add.includes(App.me.id));
				}
				if (data.delete) data.delete.forEach((item) => { o.removeClass('u'+item); if (item === App.me.id) o.removeClass('w_me'); });
				break;
			case 'kanban':
				if (data.delete) data.delete.forEach((item) => {
					let id_stage = $('#listing').find('.listing__card[data-user-to=' + item +']').attr('data-target');
					if (id_stage) App.page.helper_delete_stage_assignee(id_stage);
				});
				break;
		}

		if (App.current_page.project === id) {
			const options = JSON.parse($('.headerGeneral__right .users')?.attr('data-options') ?? '{}');
			$('.headerGeneral__right .users').load(App.helper.url.add_query(
				App.helper.endpoint.ajax(id) + '?'  + App.actions.get('project_reload_users_ava:show') + '&is_ajax=header',
				'',
				{
					'tpl_options': options
				}
			));
		}
	},

	costs: function(id, data) {
		let o;
		// Progress bars update
		let data_obj = data.shift;
		if (data_obj) {
			switch (App.page.where()) {
				case 'projects':
				case 'projects_kanban':
				case 'projects_grid':
					o = $('#obj-project' + id).find('[data-container=progress]');
					if (o.length) {
						o.each(function(i, el) {
							if (o.is('[data-used-time]')) o.attr('data-used-time', parseFloat(o.attr('data-used-time')) + data_obj.time);
							if (o.is('[data-used-money]')) o.attr('data-used-money', parseFloat(o.attr('data-used-money')) + data_obj.money);
						});
						App.page.draw_item_costs(id);
					}
					break;
			}
		}
	},

	bookmark: function(id, data) {
		if (data.on != null) {

			if (App.page.data?.exists('project', id)) {
				let new_class = App.page.data.get('project', id).class;
				if (data.on) new_class += ' p15';
				else new_class = new_class.replace('p15', '');

				App.page.data.update('project', id, { class: new_class.trim() });
			}

			let o;
			$('.bookmark[data-project=' + id + ']').toggleClass('bookmark-active', data.on).attr('data-title', App.object_state.locale[data.on ? 'star_on' : 'star_off']);
			switch (App.page.where()) {

				case 'projects':
				case 'projects_kanban':
				case 'projects_grid':
					o = $('#obj-project' + id).toggleClass('p15', data.on);
					break;
				case 'gantt':
					$('#obj-project-left'+id).toggleClass('listing__left__item-bookmarked', data.on);
					break
			}
			App.mymenu.invalidate_window('bookmarks');
			if (App.object_state.active_tab) $('.dropMP2').blink();
		}
	},

	active: function(id, data) {
		if (data.before === 'archive') {
			App.task_view_cache.invalidate_by_project(id);
			App.task_create_cache.invalidate_by_project(id);
		} else {
			App.task_view_cache.get_all().filter('[data-project='+id+']').find('.commentForm__foot').removeClass('commentForm__foot-silent');
			$('.headerGeneral__button-chat').removeClass('headerGeneral__button-chatMuted');
		}

		if (App.page.data?.exists('project', id)) App.page.data.update('project', id, { status: 1 });

		$('tr#obj-project' + id).addClass('p1');
		$('.project_archive_line[data-project='+id+']').hide();
		$('.add_task').show();
	},

	mute: function(id, data) {
		if (data.before === 'archive') {
			App.task_view_cache.invalidate_by_project(id);
			App.task_create_cache.invalidate_by_project(id);
		} else {
			App.task_view_cache.get_all().filter('[data-project='+id+']').find('.commentForm__foot').addClass('commentForm__foot-silent');
			$('.headerGeneral__button-chat').addClass('headerGeneral__button-chatMuted');
		}

		if (App.page.data?.exists('project', id)) App.page.data.update('project', id, { status: 2 });

		$('tr#obj-project' + id).removeClass('p1');
		$('.project_archive_line[data-project='+id+']').hide();
	},

	archive: function(id, data) {
		$('#obj-project'+id).remove();

		if (App.page.data?.exists('project', id)) App.page.data.update('project', id, { status: 0 });

		App.task_view_cache.invalidate_by_project(id);

		if (App.task_view.is_shown() && App.task_view.get_id_project() == id) App.task_view.obj_window.find('.commentForm').hide();
		$('.project_archive_line[data-project='+id+']').show();
		$('.add_task').hide();

		$('tr#obj-project' + id).removeClass('p1');
		App.task_create_cache.invalidate_by_project(id);
	},

	delete: function(id, data) {
		App.page.data.delete('project', id);

		let o, o2, alert;
		switch (App.page.where()) {

			case 'projects':
			case 'projects_kanban':
				$('#obj-project' + id).remove();
				App.core.call_once(function() {
					App.page.sorting_update(null, App.filter.order);
				});
				break;
			case 'projects_grid':
				$('#obj-project' + id).remove();
				App.core.call_once(function() {
					App.page.process_search();
				});
				break;
			default:
				if (App.object_state.active_tab) App.core.goto('/');
		}
	},

	workflow: function(id, data) {
		let new_workflow_id = data?.new?.id ?? '';

		let o = $('#obj-project' + id);
		if (o.length) o.attr('class', o.attr('class').replace(/\swf-?\d+/g, '') + ' wf' + new_workflow_id);

		if (App.page.data?.exists('project', id)) App.page.data.update('project', id, { id_workflow: Number(new_workflow_id) });

		App.components.project_workflow.list_by_object[id]?.forEach((el) => {
			el.setAttribute('data-workflow', String(new_workflow_id));
			App.components.project_workflow.redraw(el, data.new);
		});
	},

	custom_field: function(id, data) {
		let { id_field, value } = data;

		if (App.page.data?.exists('project', id)) {

			if (typeof value === 'string' && value.length > 20 && App.state.custom_fields.isString(id_field)) {
				value = value.substring(0, 20).trim();
			} else if (typeof value === 'string' && App.state.custom_fields.isLink(id_field)) {
				try {
					value = JSON.parse(value)?.link?.substring(0, 20).trim();
				} catch (e) {}
			}

			let new_custom_fields = App.page.data.get('project', id).custom_fields;
			if (new_custom_fields == null || Array.isArray(new_custom_fields)) new_custom_fields = {};
			new_custom_fields = { ...new_custom_fields, [id_field]: value };

			if (App.page.data?.exists('project', id)) App.page.data.update('project', id, { custom_fields: new_custom_fields });
		}
	},

	tasks_sequence: function(id, data) {
		for (let id_task in data) {
			let manual_order = data[id_task];

			let updated_data = {manual_order}

			let get_updated_data = function(orig_data) {
				return updated_data;
			}
			App.object_state.helper.common_task_update(id_task, get_updated_data, false, true);

			if (App.subtasks.data.exists('task', id_task)) {
				App.subtasks.data.update('task', id_task, updated_data);
				App.core.call_queue.add('subtasks.update', App.subtasks.update_callback, App.subtasks, null, 0.01);
			}
			switch (App.page.where()) {
				case 'tasks':
				case 'tasks_grid':
				case 'users_tasks':
				case 'kanban':
				case 'kanban_days':
				case 'gantt':
					if (App.page.data?.exists('task', id_task)) {
						App.page.data.update('task', id_task, updated_data);
					}
					break;
			}
		}
	}
}

;const STAGE_TYPE_PROGRESS = 0;
const STAGE_TYPE_DONE = 6;
const STAGE_TYPE_CANCEL = 7;

const SYSTEM_STAGE_MAP = {
	2: 0,
	3: 1,
	5: 1,
	4: 0
};

App.object_state.stage = {

	delete: function(id, data) {
		let updated_data;
		let is_updated = false;
		let ids_group_stage_progress = new Set();
		if (App.tags[id].id_type === STAGE_TYPE_PROGRESS) ids_group_stage_progress.add(App.tags[id].id_group);

		App.helper.stage.reset();

		[App.components.task_stage, App.components.project_stage].forEach((component) => component.list_all.forEach((el) => {
			if (el.tpl_data.id === id) {
				el.tpl_data.id = 0;
				component.redraw(el);
			}
		}));

		if (ids_group_stage_progress.size) App.object_state.stage.helper_update_percent_style(ids_group_stage_progress);

		// TODO: process project tags in task class

		let is_project = App.tags_group[App.tags[id].id_group].inst === 1;
		let regex_remove_class = new RegExp('(\s|\b)' + (is_project ? 'p' : '') + 't' + id + '\b', 'g');
		let regex_remove_project_class = is_project ? new RegExp('(\s|\b)t' + id + '\b', 'g') : null;
		let replace_class = ' ' + (is_project ? 'p' : '') + 'st0';
		let replace_project_class = is_project ? ' st0' : null;

		delete(App.tags[id]);

		switch (App.page.where()) {
			case 'tasks':
			case 'users_tasks':
			case 'kanban':
			case 'gantt':
				for (let id_task in App.page.data.task) {
					if (App.page.data.task[id_task].id_status === id) {
						is_updated = true;
						updated_data = {
							id_status: 0,
							class: App.page.data.task[id_task].class.replace(regex_remove_class, '')
						}
						App.page.data.update('task', id, updated_data);
					}
				}
				if (App.page.where() === 'kanban' && $('#obj-card' + id).length) { // reload page
					App.core.reload();
				}
				break

			case 'report':
				$('.listing__item').each(function() {
					if ($(this).attr('class').match(regex_remove_class)) {
						is_updated = true;
						$(this).attr('class', $(this).attr('class').replace(regex_remove_class, replace_class));
					}
				});
				break;

			case 'projects':
			case 'projects_kanban':
			case 'projects_grid':
				if (is_project) $('.listing__item, .dataTable__item').each(function () {
					if ($(this).attr('class').match(regex_remove_project_class)) {
						is_updated = true;
						$(this).attr('class', $(this).attr('class').replace(regex_remove_project_class, replace_project_class));
					}
				});

				if (is_updated) App.core.call_once(function() {
					App.mass.action_done();
					if (App.page.update_card_positions) App.page.update_card_positions(true);
				});
				break;
		}
	},

	update: function(id, data) {
		[App.components.task_stage, App.components.project_stage].forEach((component) => {
			let id_stage = id;

			Object.keys(component.id_map).forEach(function(key) {
				if (id === component.id_map[key]) id_stage = +key;
			});

			component.list_all.forEach((el) => {
				if (el.tpl_data.id === id_stage) component.redraw(el);
			})
		});

		switch (App.page.where()) {
			case 'kanban':
				let icon = $(App.components.task_stage.template({id: id}, 'icon'));
				let iname = icon.find('ws-icon').attr('name');
				let iclass = icon.attr('class');
				let id_card = id in SYSTEM_STAGE_MAP ? SYSTEM_STAGE_MAP[id] : id;
				let card = $('#obj-card' + id_card);
				if (card.length) {
				let tag_block = card.find('.listing__card__title .tag_block');
				card.find('.name').text(data.name);
				card.find('.name_').attr('class', 'name_ tag' + data.color);
				tag_block.attr('class', tag_block.attr('class').replace(App.object_state.tag.regex_remove_class, '') + ' tag' + data.color);
				tag_block.find('ws-icon').attr('name', iname);
				$('.listing__card').each(function() {
					let title_av = $(this).find('.listing__card__title a[rel=userto]');
					if (title_av.length && title_av.find('ws-icon[name=assignee_return]').length && title_av.find('ws-icon[data-tag=' + id + ']').length) {
						const title = '<div class="hint__html"><div class="hint__text">' + App.object_state.locale['return_assignee'] + '</div><hr class="hint__divider"><span class="hint__tag">' +
							'<ws-icon name="' + iname + '" class="' + iclass + '" data-tag="' + id + '"></ws-icon>' + ' ' + App.tags[id]['name'] +
							'</span></div>';
						title_av.find('ws-icon[data-tag=' + id + ']').attr('name', iname).attr('class', iclass).attr('data-title', title);
					}
				});
				}
				break;
		}

		let tag = App.task_view_cache.get_all().add('body').find('ws-icon[data-tag=' + id + ']');
		tag.each(function () {
			if (!$(this).parent().is('a[rel=userto]') && !$(this).closest('.tag_block').length) {
				$(this).next('.in').text(data.name);
				$(this).attr('class', $(this).attr('class').replace(App.object_state.tag.regex_remove_class, '') + ' tag' + data.color);
			} else {
				let el = $(this).closest('.tag_block');
				el.attr('class', el.attr('class').replace(App.object_state.tag.regex_remove_class, '') + ' tag' + data.color);
			}
		});
	},

	project_status: function(id, data) {
		if ('status' in data) {
			if (App.page.where() === 'kanban' && App.current_page.project == data.id_project) {
				$('#obj-card' + id + '').toggleClass('listing__card-prohibited', !data.status);
				$('#kanbanAddStage_menu .menu__item[data-id=' + id + ']').toggleClass('menu__item-disableIrrelevant', data.status);
				$('#kanbanNextStage_menu .menu__item[data-id=' + id + ']').toggleClass('menu__item-disableIrrelevant', !data.status);
				if (data.status) {
					if (!$('#kanbanAddStage_menu .menu__item').not('.menu__item-disableIrrelevant').length) {
						$('.listing__cardAddButton').removeClass('listing__cardAddButton-visible');
					}
				} else {
					$('.listing__cardAddButton').addClass('listing__cardAddButton-visible');
				}
				App.page.update_container_size(true);
			}
			// moved to: App.project_view.onBoot:
			// if (App.project_view.is_shown() && App.modal.obj_window.find('.projectView').attr('data-id') == data.id_project) {
			// 	$('#obj-tag' + id).toggleClass('projectSettings__item-off', !data.status);
			// }
		}
		if ('next_stage' in data) {
			if (App.page.where() === 'kanban' && App.current_page.project === data.id_project) {
				let obj_replace = $('#obj-card'+id+' .td_next ws-btn button').length ? $('#obj-card'+id+' .td_next ws-btn button') : $('#obj-card'+id+' .td_next');
				if (data.next_stage) obj_replace.html(data.next_stage ? App.helper.template.fill('kanbanNew_nextStage', {
					name: App.tags[data.next_stage].name,
					color: App.tags[data.next_stage].color,
					percent_style: App.tags[data.next_stage].percent_style,
					icon: App.tags_type_icon[0][App.tags[data.next_stage].id_type],
					id_tag: data.next_stage
				}) : '').removeClass('hide_to_hover');
				$('#obj-card'+id).attr('data-next-stage', data.next_stage);
			}
			// moved to: App.project_view.onBoot:
			// if (App.project_view.is_shown() && App.project_view.id == data.id_project) {
			// 	$('#obj-tag'+id).attr('data-next-stage', data.next_stage);
			// 	$('#obj-tag'+id+' .nextStage .data').html(data.next_stage ? App.helper.template.fill('workflow_nextStage', {
			// 		name: App.tags[data.next_stage].name,
			// 		color: App.tags[data.next_stage].color,
			// 		percent_style: App.tags[data.next_stage].percent_style,
			// 		icon: App.tags_type_icon[0][App.tags[data.next_stage].id_type],
			// 	}) : '');
			// 	$('#obj-tag'+id+' .nextStage').toggleClass('nextStage-active', !!data.next_stage);
			// }
		}
		if ('id_user_to' in data) {
			if (App.page.where() === 'kanban' && App.current_page.project == data.id_project) {
				if (data.id_user_to) {
					$('#obj-card' + id + ' .listing__card__title .av_pre').html(App.helper.team(data.id_user_to, 'avatar'))
						.find('.av_sm').attr('data-title', App.object_state.locale['assignee'] +': ' + App.helper.team(data.id_user_to, 'name'));
				} else {
					$('#obj-card' + id + ' .listing__card__title .av_pre').html('');
				}
				$('#obj-card'+id+' .task_quick_add .av_place').html(App.helper.team(data.id_user_def, 'avatar')).next().val(data.id_user_def);
			}
			//// moved to: App.project_view.onBoot:
			// if (App.project_view.is_shown() && App.modal.obj_window.find('.projectView').attr('data-id') == data.id_project) {
			// 	if (data.id_user_to) {
			// 		$('#obj-tag'+id+' .ava .data').html(App.helper.team(data.id_user_to, 'avatar'))
			// 			.find('.av_sm').attr('data-title', App.object_state.locale['assignee'] +': ' + App.helper.team(data.id_user_to, 'name'));
			// 	} else {
			// 		$('#obj-tag'+id+' .ava .data').html('<ws-icon name="none"></ws-icon>');
			// 	}
			// }
		}
		if ('id_tag_from' in data) {
			if (App.page.where() === 'kanban' && App.current_page.project == data.id_project) {
				const av_pre_el = $('#obj-card' + id + ' .listing__card__title .av_pre');
				const ava_el = av_pre_el.find('[data-user]');
				const id_user_to = ava_el.attr('data-user') ?? '';
				av_pre_el.find('.tag').remove();
				if (data.id_tag_from) {
					let icon = $(App.components.task_stage.template({id: data.id_tag_from}, 'icon'));
					const title = '<div class="hint__html"><div class="hint__text">' + App.object_state.locale['return_assignee'] + '</div><hr class="hint__divider"><span class="hint__tag">' +
						'<ws-icon name="' + icon.find('ws-icon').attr('name') + '" class="' + icon.attr('class') + '" data-tag="' + data.id_tag_from + '"></ws-icon>' + ' ' + App.tags[data.id_tag_from]['name'] +
						'</span></div>';
					av_pre_el.append(App.components.task_stage.template({id: data.id_tag_from}, 'icon')).attr('data-title', title).attr('data-title-config', 'right')
						.find('.tag').removeAttr('data-title');
					ava_el.removeAttr('data-title');
				} else {
					av_pre_el.removeAttr('data-title');
					if (id_user_to) {
						ava_el.not('[data-title]').attr('data-title', App.object_state.locale['assignee'] +': ' + App.helper.team(id_user_to, 'name'));
					}
				}
			}
			//// moved to: App.project_view.onBoot:
			// if (App.project_view.is_shown() && App.modal.obj_window.find('.projectView').attr('data-id') == data.id_project) {
			// 	$('#obj-tag'+id+' .ava .data').find('.tag').remove();
			// 	if (data.id_tag_from) {
			// 		$('#obj-tag'+id+' .ava .data').append(App.components.task_stage.template({id: data.id_tag_from}, 'icon'))
			// 			.find('.tag').removeAttr('data-title');
			// 	}
			// }
		}
	},

	helper_update_percent_style: function(ids_group) {
		let all_stages = [];
		ids_group.forEach(function(id_group) {
			let stages = Object.keys(App.tags).map(Number).filter(function(id_tag) {
				return App.tags[id_tag].id_group === id_group && App.tags[id_tag].id_type === STAGE_TYPE_PROGRESS;
			}).sort((a, b) => App.helper.sort.compare(App.tags[a].order, App.tags[b].order));

			let i = 0;
			stages.forEach(function(id_tag) {
				App.tags[id_tag].percent_style = ' style="--percent: ' + 0.01*Math.round(100*++i / Math.max(stages.length, 1)) + 'turn"';
				all_stages.push(id_tag);
			});
		});
		[App.components.task_stage, App.components.project_stage].forEach((component) => component.list_all.forEach((el) => {
			if (all_stages.includes(el.tpl_data.id)) component.redraw(el);
		}));

		// TODO move to page.account_labels.js
		switch (App.current_page.where) {
			case 'account_labels':
				all_stages.forEach(function(id_tag) {
					$('#obj-tag' + id_tag).find('ws-icon.tag').attr('style', App.tags[id_tag].percent_style.replace(' style="', '').replace('"', ''));
				});
				break;
		}

		all_stages.forEach(function(id_tag) {
			let tag = App.task_view_cache.get_all().add('body').find('ws-icon[data-tag=' + id_tag + ']');
			tag.attr('style', App.tags[id_tag].percent_style.replace(' style="', '').replace('"', ''));
		});

	}
}

;App.object_state.tag = {
	// TODO: websocket only

	regex_remove_class: /(\s|\b)tag\d+\b/g,

	add: function(id, data) {
		let ids_group_stage_progress = new Set();
		if (data.id_type === STAGE_TYPE_PROGRESS) {
			ids_group_stage_progress.add(data.id_group);
			App.object_state.stage.helper_update_percent_style(ids_group_stage_progress);
		}

		App.tags[id] = data;

		App.helper.stage.reset();
	},

	delete: function(id, data) {
		if (App.tags_group[data.id_group].stage) {
			App.object_state.stage.delete(id, data);
			return;
		}

		let updated_data;
		let is_updated = false;
		let is_project = App.tags_group[data.id_group].inst === 1;

		delete(App.tags[id]);

		[App.components.task_tags, App.components.project_tags].forEach((component) => component.list_all.forEach((el) => {
			if (el.tpl_data.tags.includes(id)) {
				if (data.delete_data_linkage) el.tpl_data.tags = el.tpl_data.tags.filter(id_tag => id_tag !== id);
				component.redraw(el);
			}
		}));

		let tag = App.task_view_cache.get_all().add('body').find('.tag[data-tag=' + id + ']');
		tag.remove();

		// TODO: process project tags in task class

		let regex_remove_class = new RegExp('(\s|\b)' + (is_project ? 'p' : '') + 't' + id + '\b', 'g');
		let regex_remove_project_class = is_project ? new RegExp('(\s|\b)t' + id + '\b', 'g') : null;

		switch (App.page.where()) {
			case 'tasks':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				for (let id_task in App.page.data.task) {
					if (App.page.data.task[id_task].class.match(regex_remove_class)) {
						is_updated = true;
						updated_data = {
							class: App.page.data.task[id_task].class.replace(regex_remove_class, '')
						}
						App.page.data.update('task', id, updated_data);
					}
				}
				break

			case 'report':
				$('.listing__item').each(function() {
					if ($(this).attr('class').match(regex_remove_class)) {
						is_updated = true;
						$(this).attr('class', $(this).attr('class').replace(regex_remove_class, ''));
					}
				});
				break;

			case 'projects':
			case 'projects_kanban':
			case 'projects_grid':
				if (is_project) $('.listing__item, .dataTable__item').each(function () {
					if ($(this).attr('class').match(regex_remove_project_class)) {
						is_updated = true;
						$(this).attr('class', $(this).attr('class').replace(regex_remove_project_class, ''));
					}
				});

				if (is_updated) App.core.call_once(function() {
					App.mass.action_done();
					if (App.page.update_card_positions) App.page.update_card_positions(true);
				});
				break;
		}
	},

	update: function(id, data) {
		let old_data = App.helper.object.clone(App.tags[id]);
		let drag = data.drag;
		delete(data.drag)

		if (data.order !== old_data.order || data.id_group !== old_data.id_group) {
			Object.keys(App.tags).map(Number).filter(function(id_tag) {
				return App.tags[id_tag].id_group === data.id_group;
			}).forEach(function(id_tag) {
				if (id !== id_tag && App.tags[id_tag].order >= data.order) App.tags[id_tag].order++;
			});
		}

		if (data.id_group !== old_data.id_group) App.project_view.on_tag_group_change(old_data.id_group);

		let ids_group_stage_progress = new Set();
		if (App.tags[id].id_type === STAGE_TYPE_PROGRESS) ids_group_stage_progress.add(data.id_group);
		App.tags[id] = data;
		if (App.tags[id].id_type === STAGE_TYPE_PROGRESS) ids_group_stage_progress.add(data.id_group);


		if (ids_group_stage_progress.size) App.object_state.stage.helper_update_percent_style(ids_group_stage_progress);

		if (App.tags_group[App.tags[id].id_group].stage) {
			App.object_state.stage.update(id, data);
			return;
		}

		// ------------------------------------------------------------------------------------------------------------

		[App.components.task_tags, App.components.project_tags].forEach((component) => component.list_all.forEach((el) => {
			if (el.tpl_data.tags.includes(id)) component.redraw(el);
		}));

		let tag = App.task_view_cache.get_all().add('body').find('.tag[data-tag=' + id + ']');

		tag.text(data.name).each(function() {
			$(this).attr('class', $(this).attr('class').replace(App.object_state.tag.regex_remove_class, '') + ' tag' + data.color);
		});
	},

	project_status: function(id, data) {
		if (App.tags_group[App.tags[id].id_group].stage) App.object_state.stage.project_status(id, data);
	},
}

;App.object_state.tag_group = {

	_order_func: function ([id_a, a], [id_b, b]) {

		if ((a.required ?? false) != (b.required ?? false)) return (a.required ?? false) ? -1 : 1;
		if ((a.default ?? false) != (b.default ?? false)) return (a.default ?? false) ? -1 : 1;
		if ((a.once ?? false) != (b.once ?? false)) return (a.once ?? false) ? -1 : 1;
		if ((a.stage ?? false) != (b.stage ?? false)) return (a.stage ?? false) ? -1 : 1;
		if ((a.hidden ?? false) != (b.hidden ?? false)) return (a.hidden ?? false) ? 1 : -1;
		if ((a.usage ?? 0) != (b.usage ?? 0)) return +(b.usage ?? 0) - +(a.usage ?? 0);

		const al = String(a.name ?? '').toLowerCase();
		const bl = String(b.name ?? '').toLowerCase();
		if (al < bl) return -1;
		if (al > bl) return 1;
		return 0;
		// return App.helper.sort.compare_strings_natural(a.name, b.name);
		// return +id_a - +id_b;
	},

	add: function(id, data) {
		App.tags_group[id] = data;

		App.tags_group_order = Object.entries(App.tags_group)
				.sort(App.object_state.tag_group._order_func)
				.map(([id]) => +id);
	},

	update: function(id, data) {
		let need_sort = false;
		if (!(id in App.tags_group)) {
			let ids_tag = [];
			for (let id_tag in data.tags) {
				ids_tag.push(id_tag);
				App.tags[id_tag] = data.tags[id_tag][i];
			}
			delete(data.tags);
			App.tags_group[id] = data;

			if (ids_tag.length) {
				[App.components.task_tags, App.components.project_tags].forEach((component) => component.list_all.forEach((el) => {
					if (el.tpl_data.tags.filter(id_tag => ids_tag.includes(id_tag)).length) {
						component.redraw(el);
					}
				}));
			}

			need_sort = true;
		} else {

			const keys = [
				'once', 'required',
				'default', 'hidden',
				'usage', 'name',
			];

			keys.forEach(key => {
				if (data[key] !== null && App.tags_group[id][key] != data[key]) {
					App.tags_group[id][key] = data[key];
					need_sort = true;
				}
			});
		}

		if (need_sort) {
			App.tags_group_order = Object.entries(App.tags_group)
				.sort(App.object_state.tag_group._order_func)
				.map(([id]) => +id);

			App.helper.stage.reset();
		}
	},

	delete: function(id, data) {
		let is_updated;

		delete(App.tags_group[id]);

		if (data['move_labels']) {
			for (let id_tag in App.tags) if (App.tags[id_tag].id_group === id) App.tags[id_tag].id_group = data['move_labels'];
		} else {
			let ids_tag = [];
			for (let id_tag in App.tags) if (App.tags[id_tag].id_group === id) {
				ids_tag.push(id_tag);
				delete (App.tags[id_tag])
			}
			if (!ids_tag.length) return;

			[App.components.task_tags, App.components.project_tags].forEach((component) => component.list_all.forEach((el) => {
				if (el.tpl_data.tags.filter(id_tag => ids_tag.includes(id_tag)).length) {
					component.redraw(el);
				}
			}));

			let tag = App.task_view_cache.get_all().add('body').find('.tag[data-tag=' + id + ']').filter(function () {
				return ids_tag.includes(parseInt($(this).attr('data-tag')))
			});
			tag.remove();

			let regex_remove_class = new RegExp('(\s|\b)(t|st)(' + ids_tag.join('|') + ')\b', 'g');

			switch (App.page.where()) {
				case 'tasks':
				case 'users_tasks':
				case 'kanban':
				case 'gantt':
					for (let id_task in App.page.data.task) {
						if (App.page.data.task[id_task].class.match(regex_remove_class)) {
							is_updated = true;
							updated_data = {
								class: App.page.data.task[id_task].class.replace(regex_remove_class, '')
							}
							App.page.data.update('task', id, updated_data);
							if (id_task in App.page.dom.task) App.page.dom.task[id_task].find('.tag[data-tag=' + id + ']').remove();
						}
					}
					break

				case 'report':
					$('.listing__item').each(function () {
						if ($(this).attr('class').match(regex_remove_class)) {
							is_updated = true;
							$(this).attr('class', $(this).attr('class').replace(regex_remove_class, '')).find('.tag[data-tag=' + id + ']').remove();
						}
					});
					break;

				case 'projects':
				case 'projects_kanban':
				case 'projects_grid':
					$('.listing__item, .dataTable__item').each(function () {
						if ($(this).attr('class').match(regex_remove_class)) {
							is_updated = true;
							$(this).attr('class', $(this).attr('class').replace(regex_remove_class, '')).find('.tag[data-tag=' + id + ']').remove();
						}
					});

					if (is_updated)	App.core.call_once(function() {
						App.mass.action_done();
						if (App.page.update_card_positions) App.page.update_card_positions(true);
					});
					break;
			}
		}

		App.helper.stage.reset();
	},

}

;App.object_state.task = {

	permissions: function(id, data) { // I don't know what to do
		if (data.lost) {
			if (App.object_state.active_tab) {
				App.object_state.task.helper_invalidate_task(id);
			}
		}
	},

	visibility: function(id, data) {

		let updated_data = {
			hidden: data.hidden,
		}

		// FYI: `hidden` is not a part of DB data
		// let get_updated_data = function(orig_data) {
		// 	return updated_data;
		// }
		// App.object_state.helper.common_task_update(id, get_updated_data, false, true);

		if (App.subtasks.data.exists('task', id)) {
			// App.helper.object.append(App.subtasks.data.task[id], updated_data);
			App.subtasks.dom.invalidate(id);
		} else {
			// create if not exists
			if (App.object_state.task.helper_match_viewing_tasks(data.object)) App.subtasks.data.add('task', id, data.object);
		}

		switch (App.page.where()) {

			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) {
					if (App.page.where() === 'tasks_grid' && App.page.dom.task[id]) {
						App.page.draw_item_visibility(id, data);
					}
				} else if (App.object_state.task.helper_match_page_project(data.object)) {
					App.page.data.add('task', id, data.object);
				}
				break;
		}

		if (data.object.status === 4) {
			App.chat_view.on_chat_members(id, data.hidden);
		}
	},

	move: function(id, data) {

		let updated_data = {
			id_project: data.id_project,
			id_parent: data.id_parent,
			id_parent_top: data.id_parent_top,
		}
		let get_updated_data = function(orig_data) {
			return updated_data;
		}
		App.object_state.helper.common_task_update(id, get_updated_data, false, true);

		if (App.subtasks.data.exists('task', id)) {
			if (App.object_state.task.helper_match_viewing_tasks(data)) {
				App.subtasks.data.update('task', id, updated_data, true);
			} else {
				App.subtasks.data.delete('task', id);
			}
		} else {
			// create if not exists
			if (App.object_state.task.helper_match_viewing_tasks(data)) App.subtasks.data.add('task', id, data);
		}

		switch (App.page.where()) {

			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) {
					if (App.object_state.task.helper_match_page_project(data)) {
						App.helper.object.append(App.page.data.task[id], updated_data);
						App.page.dom.invalidate('task', id, true);
					} else {
						App.page.data.delete('task', id);
					}
				} else {
					// create if not exists
					if (App.object_state.task.helper_match_page_project(data)) App.page.data.add('task', id, data);
				}
				break;
		}

		App.object_state.task.helper_invalidate_task(id);
	},

	order: function (id, data) {
		let updated_data = {
			manual_order: data.manual_order,
		}

		let get_updated_data = function(orig_data) {
			return updated_data;
		}
		App.object_state.helper.common_task_update(id, get_updated_data, false, true);

		if (App.subtasks.data.exists('task', id)) {
			App.subtasks.data.update('task', id, updated_data);
			for (let id_other in App.subtasks.data.task) {
				if (id_other != id && App.subtasks.data.task[id_other]['id_parent'] === App.subtasks.data.task[id]['id_parent'] && App.subtasks.data.task[id_other]['manual_order'] >= data.manual_order) App.subtasks.data.task[id_other]['manual_order']++;
			}
			App.core.call_queue.add('subtasks.update', App.subtasks.update_callback, App.subtasks, null, 0.01);
		}
		switch (App.page.where()) {
			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) {
					App.page.data.update('task', id, updated_data);
					if (!data['id_parent_top']) for (let id_other in App.page.data.task) {
						if (id_other != id && !App.page.data.task[id_other]['id_parent_top'] && App.page.data.task[id_other]['id_project'] === App.page.data.task[id]['id_project'] && App.page.data.task[id_other]['manual_order'] >= data.manual_order) App.page.data.task[id_other]['manual_order']++;
					}
				}
				break;
		}
	},

	priority: function(id, data) {

		let update_filter_data_count = function(class_name, inc) {
			let el = $(class_name);
			if (el.length) {
				el = el.first();
				let tasks_count = parseInt(el.attr('data-tasks-count'), 10) || 0;
				let min_inc = (inc > 0) ? 1 : 0;
				tasks_count = Math.max(min_inc, tasks_count + inc);
				el.attr('data-tasks-count', tasks_count);
			}
		}

		let get_updated_data = function(orig_data) {
			return {
				important: data.id,
				class: orig_data.class.replace(App.components.task_priority.regex_remove_class, '') + ' p' + (100 + data.id)
			}
		}

		// also should move to specific modules:
		App.object_state.helper.common_task_update(id, get_updated_data);

		// should move to SPECIFIC pages:
		switch (App.page.where()) {
			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) {
					let task_class_data = App.page.data.task[id].class;

					App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));

					let old_prior = task_class_data.match(/\bp10[0-9]\b|\bp110\b/g);
					if (old_prior) {
						old_prior = old_prior[0].match(/\d+/)[0];
						update_filter_data_count('#filterItem__priority__menu [data-id="' + old_prior + '"]', -1);
						update_filter_data_count('#filterItem__priority__menu [data-id="' + (100 + data.id) + '"]', 1);
					}
				}
				break;
		}

		// Should move to task_view.js:
		let prior = App.task_view_cache.get_all().add('body').find('.priorb[data-task=' + id + ']');
		prior.attr('class', 'priorb prior' + data.id).html(data.id === 0 ? PRIOR0_HTML : data.html);
	},

	tag: function(id, data) {
		let o;

		data.class = '';
		data.tags.forEach(function(id_tag) {
			if (id_tag in App.tags) { // Visible for me
				data.class += ' t' + id_tag;
			}
		});

		let get_updated_data = function(orig_data) {
			return {
				class: orig_data.class.replace(App.components.task_tags.regex_remove_class, '') + data.class
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		if (App.subtasks.data.exists('task', id)) {
			if (id in App.subtasks.dom.task) App.subtasks.dom.task[id].find('[data-container=tags]').html(data.html);
		}

		switch (App.page.where()) {

			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) {
					App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				}
				break;
			case 'report':
				o = $('#obj-task' + id);
				if (o.length) {
					o.find('.tags').html(data.html);
					if (App.object_state.active_tab) App.core.call_once(function() {
						App.mass.action_done();
					});
				}
				break;

		}
		o = App.task_view_cache.get_all().find('#obj-task-view' + id);
		if (o.length) {
			o.find('[data-container=tags]').html(data.html || ('<i class="ico ico_l ico_tag"></i><i class="onch">' + App.object_state.locale['no_labels'] + '</i>'));
		};
	},

	status: function(id, data) {
		if (data.id == 1) data.id = 0; // Correct backlog process

		let get_updated_data = function(orig_data) {
			return {
				class: orig_data.class.replace(App.components.task_stage.regex_remove_class, '') + ' st' + data.id,
				id_stage: data.id,
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		switch (App.page.where()) {

			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				if (App.page.where() === 'kanban') {
					let tag = null;
					if (id) tag = $('.listing__item-clone[data-task=' + id + ']').find('.tag_');
					if (tag) tag.replaceWith('<span class="tag_ ' + data.class + '"><font>' + App.helper.html.encode(data.name) + '</font></span>');
					$('#obj-card' + id).removeClass('listing__card-prohibited');
				}
				break;
		};
	},

	user_to: function(id, data) {
		let o, o2, alert, user_to // task item

		let get_updated_data = function(orig_data) {
			return {
				id_user_to: data.id,
				class: orig_data.class.replace(/(\s|\b)u\d+/g, '').replace(/(\s|\b)ug\d+/g, '').replace(/(\s|\b)ugs\d+/.g, '')
					+ ' u' + data.id + ' ug' + data.id_group + ' ugs' + data.id_group + '_' + data.id_group_sub
			}
		}

		console.log('user_to:', id);
		App.object_state.helper.common_task_update(id, get_updated_data);

		if (App.subtasks.data.exists('task', id)) {
			if (id in App.subtasks.dom.task) App.subtasks.dom.task[id].find('.av_pre[data-title]').each(function() {
				let arr = $(this).attr('data-title').split(' ➝ ');
				$(this).attr('data-title', arr[0] + ' ➝ ' + App.hint.helper_user_wrapper(data.id));
			});
		}

		switch (App.page.where()) {

			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) {
					App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
					if (id in App.page.dom.task) {
						if (App.page.where() === 'tasks') {
							App.page.dom.task[id].find('.td_user [data-container=user_to]').html(data.name_alt).prev().attr('rel', data.id).html(data.avatar);
						}
						if (App.page.where() === 'kanban' || App.page.where() === 'kanban_days' || App.page.where() === 'gantt') {
							App.page.dom.task[id].find('.av_pre').html(data.avatar).filter('[data-title]').each(function () {
								let arr = $(this).attr('data-title').split(' ➝ ');
								$(this).attr('data-title', arr[0] + ' ➝ ' + App.hint.helper_user_wrapper(data.id));
							});
						}
						if (App.page.where() === 'users_tasks') {
							console.log(data);
							let avatar = '<span class="assignee" data-title="' + data.name + '" data-user-name="' + data.name + '"><span class="' + (data.icon ? 'ico_ava ' : '') + 'ico_place">' + data.icon + '</span>' + data.avatar + '</span>';
							App.page.dom.task_no_match[id].html(App.page.dom.task_no_match[id].find('a.t'));
							App.page.dom.task_no_match[id].append(avatar);
						}
						if (App.page.where() === 'gantt') {
							App.page.dom.task[id].attr('data-user', data.id); // to draw user holidays
							App.page.dom.task_right[id].attr('data-user', data.id); // to draw user holidays
						}
					}
				}
				break;

			case 'report':
				o = $('#obj-task' + id);
				if (o.length) {
					alert = '';
					if (
						App.filter.data['group'] && App.filter.data['group'] != data.id_group
						|| App.filter.data['group_sub'] && App.filter.data['group'] != data.id_group_sub
						|| App.filter.data['role'] && (App.filter.data['user'] ? App.filter.data['user'] : App.me.id) != data.id
					) {
						alert = '<span class="ico ico_alert_sm data-title-l2" data-title="' + App.object_state.locale['filter_error'] + '"></span>';
					}
					o.attr('class', o.attr('class').replace(/ u\d+/g, '') + ' u' + data.id).find('.td_user .onch').html(data.name_alt + alert).parent().parent().find('.ava').attr('rel', data.id).removeClass('ava_op').html(data.avatar).filter('.ava_sm').remove();
					if (App.object_state.active_tab) App.core.call_once(function() {
						App.mass.action_done();
					});
				}
				break;

		}
	},

	user_from: function(id, data) {
		let o;

		let get_updated_data = function(orig_data) {
			return {
				class: orig_data.class.replace(/(\s|\b)a\d+/g, '').replace(/(\s|\b)ag\d+/g, '')
					+ ' a' + data.id + ' ag' + data.id_group
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		if (App.subtasks.data.exists('task', id)) {
			if (id in App.subtasks.dom.task) App.subtasks.dom.task[id].find('.av_pre').html(data.avatar).filter('[data-title]').each(function() {
				let arr = $(this).attr('data-title').split(' ➝ ');
				$(this).attr('data-title', App.hint.helper_user_wrapper(data.id) + ' ➝ ' + arr[1]);
			});
		}

		switch (App.page.where()) {

			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				if (App.page.where() === 'kanban' || App.page.where() === 'kanban_days' || App.page.where() === 'gantt') {
					App.page.dom.task[id].find('.av_pre').filter('[data-title]').each(function () {
						let arr = $(this).attr('data-title').split(' ➝ ');
						$(this).attr('data-title', App.hint.helper_user_wrapper(data.id) + ' ➝ ' + arr[1]);
					});
				}
				break;
			case 'report':
				$('#obj-task' + id).attr('class', $('#obj-task' + id).attr('class').replace(/ a\d+/g, '') + ' a"' + data.id + '"');
				if (App.object_state.active_tab) App.core.call_once(function() {
					App.mass.action_done();
				});
				break;

		}

		// o = App.task_view_cache.get_all().find('#obj-task-view' + id);
		// if (o.length) {
		// 	o.find('task-assignee .author > span').text(data.name);
		// 	//o.find('[data-container=user_from] font').text(data.name);
		// 	// TODO later:
		// 	// App.subscribe.add_user(data.id, -1);
		// }
	},

	ids_related: function (id, data) {
		App.object_state.task.helper_invalidate_relations(data);
	},

	terms: function(id, data) {

		let get_updated_data = function(orig_data) {
			let item_data = App.helper.object.clone(orig_data);
			let item_data_diff = {};
			['datestart', 'dateend', 'timeend', 'timestart', 'is_related', 'is_repeat', 'repeat_ico'].forEach((i) => {
				item_data_diff[i] = data[i];
				item_data[i] = data[i];
			});

			item_data_diff['class'] = App.components.task_terms.get_task_terms_class(item_data);

			return item_data_diff;
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		App.object_state.task.helper_invalidate_relations([id]);

		switch (App.page.where()) {
			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));

				if (App.page.where() === 'kanban_days') {
					if (id) {
						let id_day = App.page.helper_get_card(data);
						$('#obj-card' + id_day).removeClass('listing__card-prohibited');
					}
				}
				if (['kanban', 'users_tasks', 'kanban_days'].includes(App.page.where())) App.page.helper_update_terms_class(id);
				break;
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				else if (App.page.data_invisible.exists('task', id)) App.page.data_invisible.update('task', id, get_updated_data(App.page.data_invisible.task[id]));
				break;
			case 'calendar':
				App.object_state.task.helper_invalidate_task(id);
				break;
		}
	},

	name: function(id, data) {

		let o;
		let get_updated_data = function(orig_data) {
			return {
				name: data.name
			}
		}

		App.helper.task_name(id, data.name);
		App.components.update(App.components.task_name, id, data);

		document.querySelectorAll('ws-btn[data-task="' + id + '"]').forEach(function (el) {
			const truncate = parseInt(el.getAttribute('data-task-truncate'), 10);
			const text = truncate > 0 ? App.helper.string.truncate(data.name, truncate) : data.name;
			el.setAttribute('text', text);
		});
		document.querySelectorAll('.filter__item[data-task="' + id + '"] [data-container]').forEach(function (el) {
			el.textContent = data.name;
		});

		App.object_state.helper.common_task_update(id, get_updated_data);

		switch (App.page.where()) {

			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'tasks':
			case 'gantt':
			case 'tasks_grid':
				if (App.page.data?.exists('task', id)) {
					App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				}
				break;
		}

		o = App.task_view_cache.get_all().find('#obj-task-view' + id);
		if (o.length) {
			o.find('.taskView__name ws-editable').attr('value', data.name);
			o.find('.taskView__name h1 [data-role="value"]').text(data.name);
		}

		App.task_view_cache.get_all().filter('.taskView-chat').find('.commentForm-chat[data-task='+id+'] #editor .placeholder').each(function (_, element) {
			const rawTemplate = $(element).attr('data-placeholder-template');
			if (rawTemplate) {
				const renderedTemplate = App.helper.template.fill(rawTemplate, { name: data.name })
				$(element).text(renderedTemplate);
			}
		});

		if (App.page.update_parent_hints) {
			App.page.update_parent_hints();
		}

		App.task_view.sync_document_title(id);
	},

	descr: function(id, data) {
		App.object_state.task.helper_reload_description(id);
		if (data.todos) App.object_state.helper.todo_update(id, data.todos[0], data.todos[1]);
		if (data.contacts) App.object_state.helper.contacts_update(data.id_task, data.contacts);
	},

	done_date: function(id, data) {

		let get_updated_data = function(orig_data) {
			return {
				class: orig_data['class'].replace(App.components.task_terms.regex_remove_class, '') + data.class
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		let o, alert;
		switch (App.page.where()) {

			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				break;
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				else if (App.page.data_invisible.exists('task', id)) App.page.data_invisible.update('task', id, get_updated_data(App.page.data_invisible.task[id]));
				break;
			case 'report':
				alert = '';
				if (App.page.time_interval.min && data.dateclose < App.page.time_interval.min || App.page.time_interval.max && data.dateclose > App.page.time_interval.max) {
					alert = '<span class="ico ico_alert_sm data-title-l2" data-title="' + App.object_state.locale['interval_error'] + '"></span>';
				}
				$('#obj-task' + id).find('.td_close a').html(data.html + alert);
				break;
		}
	},

	attach: function(id, data) {
		let get_updated_data = function(orig_data) {
			return {
				cnt_file: data.id,
				class: orig_data.class.replace(App.components.task_attach.regex_remove_class, '')
					+ (data.id ? ' p'+ App.components.task_attach.list_task_classes['with_files'] : '')
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		switch (App.page.where()) {
			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				break;
		}

		App.object_state.task.helper_reload_description(id);
	},

	limits: function(id, data) {

		let o, alert;

		let get_updated_data = function(orig_data) {
			let item_data_diff = {}
			if ('max_time' in orig_data) item_data_diff['max_time'] = data.time;
			if ('max_money' in orig_data) item_data_diff['max_money'] = data.money;
			return item_data_diff;
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		switch (App.page.where()) {

			case 'report':
				$('#obj-task' + id).find('.plan_tm').html(data.label_report);
				break;

			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
				if (App.page.data?.exists('task', id)) {
					App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
					App.page.draw_item_costs(id);
					App.core.call_queue.add('update_progress_bars', App.page.update_progress_bars, App.page, null, 0.01);
				}
				break;

			case 'gantt':
				if (App.page.data?.exists('task', id)) {
					App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
					if (id in App.page.dom.task) App.page.dom.task_right[id].find('.tml').html(data.label_gantt).toggleClass('tml_act', 1*data.time !== 0);
				}
				break;

		}
		o = App.task_view_cache.get_all().find('#obj-task-view' + id);
		if (o.length) {
			App.task_view.costs.update(o, data, 'limit');
		}
	},

	costs: function(id, data) {
		let o, alert;

		// Progress bars update
		let data_obj = data.add || data.update || data.delete || data.shift || data.user || data.date;
		if (data_obj) {

			if (App.page.where() === 'tasks_grid'
				&& App.page?.is_report === 'costs'
				&& App.page.data
				&& !App.page.data?.exists('task', id)
				&& (!App.current_page.project || App.current_page.project === data_obj.id_project)
			) {
				// Try to get invisible task and continue
				App.page.data.loader.load('task', id, function() {
					App.object_state.task.costs(id, data);
				});
				return;
			}

			if (App.page.where() == 'tasks_grid' && App.page.report.type === 'costs') {
				const match = data_obj.dateadd >= App.time_interval.min && data_obj.dateadd <= App.time_interval.max;
				if (match) {
					App.page.report.update_item(id, data_obj, 'plus');
				}
			}

			if (App.page.costs?.update_item) {
				App.page.costs.update_item(id, data_obj, 'plus');
			}

			switch (App.page.where()) {
				case 'tasks':
				case 'tasks_grid':
				case 'users_tasks':
				case 'kanban':
				case 'kanban_days':
					if (App.page.data?.exists('task', id)) {
						App.page.draw_item_costs(id);
						App.core.call_queue.add('update_progress_bars', App.page.update_progress_bars, App.page, null, 0.01);
					}
					break;
			}

			o = App.task_view_cache.get_all().find('#obj-task-view' + id);
			if (o.length) {
				App.task_view.costs.update(o, data_obj, 'costs');
			}

		}

		if (data.add) {
			switch (App.page.where()) {
				case 'report':
					if (App.object_state.active_tab) App.page.load_costs_item(id, data.add.id);
					break;
			}
			if (App.object_state.active_tab && App.modal.is_shown()) {
				if (!('min' in App.costs_list.config) || (data_obj.dateadd >= App.costs_list.config.min && data_obj.dateadd <= App.costs_list.config.max)) {
					App.costs_list.load_item(data.add.id);
				}
			}
		}
		if (data.delete) {
			switch (App.page.where()) {
				case 'report':
					if (App.object_state.active_tab) {
						$('#obj-cost' + data.delete.id).remove();
						App.core.call_once(function() {
							App.mass.action_done();
							App.page.mass.update_menu();
							App.page.update_total?.();
						});
					}
					break;
			}
			if (App.object_state.active_tab && App.modal.is_shown())	{
				$('#obj-costs-modal' + data.delete.id).remove();
				if ($('#time_list .item').length == 0) $('#time_list').remove();
				App.costs_list.update_total();
			}
		}

		/** Costs row related logics **/

		if (data.date) {
			App.object_state.costs.date(data.date.id, data.date);
		}
		if (data.user) {
			App.object_state.costs.user(data.user.id, data.user);
		}
	},

	relations: function (id, data) {
		let payload = data.add || data.update || data.delete;
		let get_taskView_relations = function (id_task) {
			return App.task_view_cache.get_all().find('#obj-task-view' + id_task + ' .taskView__params__item[data-key=relations]')
		};

		if (data.add) {
			get_taskView_relations(id).each(function () {
				let items = App.task_view.relations.get_relations_html(this);
				items.push(payload);
				App.task_view.relations.redraw(this, items);
			})
		}
		if (data.update) {
			get_taskView_relations(id).each(function () {
				let items = App.task_view.relations.get_relations_html(this).map(function (i) {
					return i.id_related_task === payload.id_related_task ? payload : i;
				});

				if (items.find(i => i.id_related_task === payload.id_related_task) == null) {
					items.push(payload)
				}

				App.task_view.relations.redraw(this, items);
			})
		}
		if (data.delete) {
			get_taskView_relations(id).each(function () {
				let items = App.task_view.relations.get_relations_html(this).filter(function (i) {
					return i.id_related_task !== payload.id_related_task
				});
				App.task_view.relations.redraw(this, items);
			})
		}
	},

	timers: function(id, data) {

		if (App.components.task_timers.list_by_object[id]) {
			let ids;
			App.components.task_timers.list_by_object[id]?.forEach((el) => {
				ids = el.tpl_data.ids.split(',').filter((id) => !!id).map(Number);
				if (data.add) ids.push(+data.add.id_user_from);
				if (data.delete) ids = ids.filter((id) => id !== +data.delete.id_user_from);
				el.tpl_data.ids = ids.join(',');

				App.components.task_timers.redraw(el);
			});
		}

		switch (App.page.where()) {
			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.onupdate();
				break;
		}
	},

	clear: function (id, data) {
		App.comments.clear_item(data.id_last, data.type, id);

		if (data.type === 'comment') {
			App.chat_view.on_comment_clear(id);
			App.chat_view.update_counter();
		}

		if (App.object_state.active_tab) {
			App.core.call_once(function() {
				App.comments.mass.update_menu();
				App.mass.action_done();
			});
		}
	},

	delete: function(id, data) {

		App.object_state.helper.common_task_delete(id);

		switch (App.page.where()) {
			case 'tasks_grid':
				// TODO: remove last task without reload (tmp decision)
				if (!App.controls.datatable.obj.find('.dataTable__item:not([data-id='+id+'])').length) {
					App.core.reload();
				} else if (App.page.report.type === 'costs' && data.visibility_loss) {
					// Try to recheck task visibility
					App.page.data.loader.load('task', id, function() {
						if (App.page.data?.exists('task', id)) {
							App.page.dom.invalidate('task', id);
						} else {
							App.page.data.delete('task', id);
						}
					}, true);
				} else if (App.page.data?.exists('task', id)) {
					App.page.data.delete('task', id);
				}
				break;
			case 'tasks':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.delete('task', id);
				break;
			case 'calendar':
				if (App.object_state.active_tab) {
					App.core.call_once(function() {
						App.core.reload();
					});
				} else {
					App.object_state.task.helper_invalidate_task(id);
				}
				break;
		}

		App.chat_view.on_chat_delete(id);
		App.task_view.on_task_delete(id);
		App.task_explorer.update();
	},

	add: function(id, data) {

		if (data.name) App.helper.task_name(id, data.name);

		App.object_state.helper.common_task_add(id, data);

		if (data.status === 4 || data.status === 3) {
			App.chat_view.on_chat_add(id, data);
		}

		switch (App.page.where()) {
			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.object_state.task.helper_match_page_project(data)) {
					if (!data['id_parent_top']) for (let id_other in App.page.data.task) {
						if (id_other != id && !App.page.data.task[id_other]['id_parent_top'] && App.page.data.task[id_other]['id_project'] === data['id_project'] && App.page.data.task[id_other]['manual_order'] >= data.manual_order) App.page.data.task[id_other]['manual_order']++;
					}
					App.page.data.add('task', id, data);
				}
				break;

			case 'calendar':
				if (!App.current_page.project || App.current_page.project === data.id_project) App.controls.page_reloader.add(id, true);
				break;
			case 'onboarding':
				App.page.helper.action_event('task_add', id, data);
				break;
		}
		App.task_explorer.update();
	},

	helper_match_page_project: function(data) {
		if (App.current_page.project) return App.current_page.project == data.id_project;
		else return App.projects[data.id_project]?.can_view || App.page.project_extended_visibility || (App.page.is_personal && data.id_project == App.config.id_project_inbox);
	},

	helper_match_viewing_tasks: function(data) {
		let ids_task_view = App.task_view_cache.get_all_ids();
		return ids_task_view.includes(data.id_parent) || ids_task_view.includes(data.id_parent_top);
	},

	done: function(id, data) {

		// має ховатися в actions/*/mass_task_done
		// інакше заважає wizard модалкам
		// if (App.object_state.active_tab) App.core.call_once(function() {
		// 	App.modal.hide({applause: true});
		// });

		let get_updated_data = function(orig_data) {
			return {
				dateclose: data.dateclose,
				status: 1,
				class: orig_data.class.replace(App.components.task_terms.regex_remove_class, '') + data.class
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data, true);

		switch (App.page.where()) {

			case 'tasks':
			case 'tasks_grid':
				if (App.page.data?.exists('task', id)) {
					App.helper.object.append(App.page.data.task[id], get_updated_data(App.page.data.task[id]));
					if (App.page.data.task[id]['id_parent_top']) App.page.draw_item_done_progress(App.page.data.task[id]['id_parent_top']);
					App.page.dom.invalidate('task', id);
				}
				break;

			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
				if (App.page.data?.exists('task', id)) {
					App.helper.object.append(App.page.data.task[id], get_updated_data(App.page.data.task[id]));
					App.page.dom.invalidate('task', id);
				}
				break;
			case 'gantt':
				if (App.page.data?.exists('task', id)) {
					App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				} else if (App.page.data_invisible.exists('task', id)) {
					App.page.data_invisible.update('task', id, get_updated_data(App.page.data_invisible.task[id]));
				}
				break;
			case 'projects':
			case 'projects_kanban':
			case 'projects_grid':
				App.page.draw_item_costs(data.id_project);
				break;
		}

		App.object_state.task.helper_invalidate_task(id);
		App.task_explorer.update();
	},

	undone: function(id, data) {
		// має ховатися в actions/*/mass_task_reopen
		// інакше заважає wizard модалкам
		// if (App.object_state.active_tab) App.core.call_once(function() {
		// 	App.modal.hide();
		// });

		let get_updated_data = function(orig_data) {
			return {
				dateclose: data.dateclose,
				status: 0,
				class: orig_data.class.replace(App.components.task_terms.regex_remove_class, '') + data.class
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data, true);

		switch (App.page.where()) {

			case 'tasks':
			case 'tasks_grid':
				if (App.page.data?.exists('task', id)) {
					App.helper.object.append(App.page.data.task[id], get_updated_data(App.page.data.task[id]));
					if (App.page.data.task[id]['id_parent_top']) App.page.draw_item_done_progress(App.page.data.task[id]['id_parent_top']);
					App.page.dom.invalidate('task', id);
				}
				break;

			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
				if (App.page.data?.exists('task', id)) {
					App.helper.object.append(App.page.data.task[id], get_updated_data(App.page.data.task[id]));
					App.page.dom.invalidate('task', id);
				}
				break;
			case 'gantt':
				if (App.page.data?.exists('task', id)) {
					App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				} else if (App.page.data_invisible.exists('task', id)) {
					App.page.data_invisible.update('task', id, get_updated_data(App.page.data_invisible.task[id]));
				}
				break;
			case 'projects':
			case 'projects_kanban':
			case 'projects_grid':
				App.page.draw_item_costs(data.id_project);
				break;
		}

		App.object_state.task.helper_invalidate_task(id);
		App.task_explorer.update();
	},

	bookmark: function(id, data) {
		let bookmark = App.core.get_whole_dom().find('.bookmark[data-task=' + id + ']');
		bookmark.toggleClass('bookmark-active', data.on);
		bookmark.filter('.bookmark-withIcon, button').attr('data-title', function () {
			const default_title = App.object_state.locale[data.on ? 'star_on' : 'star_off']
			const data_title = data.on ? $(this).attr('data-title-on') : $(this).attr('data-title-off');
			return data_title || default_title;
		});

		bookmark = App.core.get_whole_dom().find(`.sidePanel__list #obj-task${id} .star-toggle`)
		if (bookmark.length > 0) {
			bookmark.toggleClass('star-starred', data.on)
			bookmark.removeClass('star-initial')
			bookmark = bookmark.parent();
			bookmark.attr('onclick', bookmark.attr('onclick').replace('is_on='+Number(data.on), 'is_on='+Number(!data.on)))
		}


		//bookmark.filter('.menu__item').find('.in').html(App.object_state.locale[data.on ? 'do_star_off' : 'do_star_on']);

		let get_updated_data = function(orig_data) {
			return {
				class: orig_data.class.replace(/(\s|\b)p15\b/g, '') + (data.on ? ' p15' : '')
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		switch (App.page.where()) {

			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]), App.page.where() === 'tasks_grid');
				if (['kanban', 'users_tasks', 'kanban_days'].includes(App.page.where())) $('#obj-task' + id).toggleClass('listing__item-bookmarked', data.on);
				if (App.page.where() === 'gantt') $('#obj-task-left'+id).toggleClass('listing__left__item-bookmarked', data.on);
				break;
		}
		App.chat_view.on_chat_pin(id, data.on);
	},

	waitme_delete: function(id) {
		const selector = '#dropwait' + id + ', #dropwait' + id + 'menu';

		$(selector).remove();

		if (App.subtasks.data.exists('task', id)) {
			if (id in App.subtasks.dom.task) App.subtasks.dom.task[id].find(selector).remove();
		}
	},

	like: function(id, data) {},

	todo: function(id, data) {

		let with_todos = data.cnt - data.cnt_done;
		App.components.task_todos?.list_by_object[id]?.forEach((el) => {
			if (data.status) {
				el.tpl_data.cnt_done++;
			} else {
				el.tpl_data.cnt_done--;
			}
			el.tpl_data.percent_done = Math.round(100 * el.tpl_data.cnt_done / el.tpl_data.cnt);
			App.components.task_todos.redraw(el);
		});

		let get_updated_data = function(orig_data) {
			return {
				class: orig_data.class.replace(App.components.task_todos.regex_remove_class, '')
					+ (with_todos ? ' p'+ App.components.task_todos.list_task_classes['with_todos'] : '')
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		switch (App.page.where()) {
			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				break;
		}

		let cache_data = App.task_view_cache.pop_by_id(id);
		if (cache_data) {
			cache_data.obj_window.find('ol.todo li[rel]').each(function() {
				let a = $(this).attr('rel').split('|');
				if (a[0] == data.id) {
					if (data.status) $(this).addClass('pre_act ' + data.class).find('label').attr('data-title', data.hint).addClass('act').find('input').prop('checked', true);
					else $(this).removeClass('pre_act done done_td done_yd').find('label').attr('data-title', data.hint).removeClass('act').find('input').prop('checked', false);
				}
			});
		}
	},

	reminders: function (id, data) {
		let get_taskView_reminders = function (id_task) {
			return App.task_view_cache.get_all().find('#obj-task-view' + id_task + ' .taskView__params__item[data-key=reminders]')
		};

		if (data.add) {
			get_taskView_reminders(id).each(function () {
				let items = App.task_view.reminders.get_reminders_html(this);
				items.push(data.add);
				App.task_view.reminders.redraw(this, items);
			})
		}
		if (data.update) {
			get_taskView_reminders(id).each(function () {
				let items = App.task_view.reminders.get_reminders_html(this).map(function (i) {
					return i.id === data.update.id ? data.update : i;
				});

				if (items.find(i => i.id === data.update.id) == null) {
					items.push(data.update)
				}

				App.task_view.reminders.redraw(this, items);
			})
		}
		if (data.delete) {
			get_taskView_reminders(id).each(function () {
				let items = App.task_view.reminders.get_reminders_html(this).filter(function (i) {
					return i.id !== data.delete.id
				});
				App.task_view.reminders.redraw(this, items);
			})
		}

		/** @important bulk update */
		if (data.dates) {
			for (let id_reminder in data.dates) {
				let el = get_taskView_reminders(id).find('.reminderListing__item[data-reminder=' + id_reminder + '] task-reminder-term').get(0);
				if (el) App.components.task_reminder_terms.redraw(el, data.dates[id_reminder]);
			}
		}

		if (App.object_state.active_tab) App.core.send_message_to_other_devices({
			command: 'object_state',
			data: {
				obj_type: 'task',
				obj_id: id,
				obj_data: { reminders: data }
			},
		}, 'task_reminders' + id);
	},

	meets: function (id, data) {
		let get_taskView_meets = function (id_task) {
			return App.task_view_cache.get_all().find('#obj-task-view' + id_task + ' .taskView__params__item[data-key=meets]')
		};

		// if (data.refresh) {
		// 	get_taskView_meets(id).each(function () {
		// 		App.task_view.meets.redraw(this, data.refresh);
		// 	})
		// }
		if (data.add) {
			get_taskView_meets(id).each(function () {
				let items = App.task_view.meets.get_meets_html(this);
				items.push(data.add);
				App.task_view.meets.redraw(this, items);
			})
		}
		if (data.update) {
			get_taskView_meets(id).each(function () {
				let items = App.task_view.meets.get_meets_html(this).map(function (i) {
					return i.id === data.update.id ? data.update : i;
				});

				if (items.find(i => i.id === data.update.id) == null) {
					items.push(data.update)
				}

				App.task_view.meets.redraw(this, items);
			})
		}
		if (data.delete) {
			get_taskView_meets(id).each(function () {
				let items = App.task_view.meets.get_meets_html(this).filter(function (i) {
					return i.id !== data.delete.id
				});
				App.task_view.meets.redraw(this, items);
			})
		}

		if (App.object_state.active_tab) App.core.send_message_to_other_devices({
			command: 'object_state',
			data: {
				obj_type: 'task',
				obj_id: id,
				obj_data: { meets: data }
			},
		}, 'task_meets' + id);
	},

	subscribers: function (id, data) {
		let cache_data = App.task_view_cache.pop_by_id(id);
		if (cache_data) {
			App.task_view.subscribers.update_html(cache_data.obj_window, data.ids_user, id);
		}

		// TODO see no usage of `el.tpl_data.subs`… remove?
		App.components.task_unseen.list_by_object[id]?.forEach((el) => {
			el.tpl_data.subs = data.ids_user.includes(App.me.id);
			// TODO do we need redraw here?
		});

		let get_updated_data = function(orig_data) {
			let new_subscribed = data.ids_user.includes(App.me.id);
			let old_subscribed = App.object_state.task.helper_class_to_subscribers(orig_data.class).includes(App.me.id);
			if (new_subscribed !== old_subscribed) {
				orig_data.class = orig_data.class.replace(App.components.task_unseen.regex_remove_class, '');
			}
			return {
				class: orig_data.class.replace(/(\s|\b)s\d+\b/g, '')
					+ (data.ids_user.length ? ' s' + data.ids_user.join(' s') : '')
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		switch (App.page.where()) {
			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				break;
		}

		let o = $('.chatList__item[data-chat=' + id + ']');
		let is_sub_me = data.ids_user.includes(App.me.id);
		if (o.length) {
			o.toggleClass('chatList__item-muted', !is_sub_me);
			App.chat_view.update_counter();
		}
	},

	topic: function(id, data) {
		let o = App.modal.obj_window;
		if (o.length) o.find('.projectView__group-topic .projectView__group__content').html(data.topic);
	},

	color: function(id, data) {
		let sel = '.proj_color[data-chat=' + id + ']', o = $(sel);

		Object.keys(App.mymenu.cache).forEach(function(k) {
			o = o.add(App.mymenu.cache[k].obj_window.find(sel));
		});

		o.attr('class', 'proj_color proj_color' + data.value).attr('data-color', data.value);
		App.task_panel.update_symbols();
	},

	emoji: function(id, data) {
		let sel = '.proj_color[data-chat=' + id + '] ws-emoji', o = $(sel);

		Object.keys(App.mymenu.cache).forEach(function(k) {
			o = o.add(App.mymenu.cache[k].obj_window.find(sel));
		});

		o.attr('id', data.value || '');
		App.task_panel.update_symbols();
	},

	custom_field: function(id, data) {
		let {id_field, value, before} = data;

		if (typeof value === 'string' && value.length > 20 && App.state.custom_fields.isString(id_field)) {
			value = value.substring(0, 20).trim();
		} else if (typeof value === 'string' && App.state.custom_fields.isLink(id_field)) {
			try {
				value = JSON.parse(value)?.link?.substring(0, 20).trim();
			} catch (e) {}
		}

		let get_updated_data = function(orig_data) {
			let custom_field = orig_data.custom_fields == null || Array.isArray(orig_data.custom_fields) ? {} : {...orig_data.custom_fields};

			return {
				custom_fields: { ...custom_field, [id_field]: value },
			}
		}

		// also should move to specific modules:
		App.object_state.helper.common_task_update(id, get_updated_data);

		// should move to SPECIFIC pages:
		switch (App.page.where()) {
			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) {
					App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				}
				break;
		}
	},

	read: function (id, data) {},

	seen: function(id) {
		let get_updated_data = function(orig_data) {
			return {
				class: orig_data.class.replace(App.components.task_unseen.regex_remove_class, '')
			}
		}

		App.object_state.helper.common_task_update(id, get_updated_data);

		switch (App.page.where()) {
			case 'tasks':
			case 'tasks_grid':
			case 'users_tasks':
			case 'kanban':
			case 'kanban_days':
			case 'gantt':
				if (App.page.data?.exists('task', id)) App.page.data.update('task', id, get_updated_data(App.page.data.task[id]));
				break;
		}

		$('.pre_unseen[data-task='+id+']').removeClass('pre_unseen').find('button').removeClass('btn-solid').addClass('btn-outline');
	},

	seen_assignee: function(id) {
		App.components.task_assignee?.list_by_object[id]?.forEach((el) => {
			App.components.task_assignee.redraw(el, {is_seen: true});
		});
	},

	helper_invalidate_task: function(id) {
		let o;

		App.task_view_cache.invalidate_by_id(id); // reload taskView windows

		App.task_view_cache.helper_invalidate_children_buttons(id); // reload buttons in taskView windows

		switch (App.page.where()) {

			case 'calendar':
				o = $('.listing__item[data-id=' + id + ']');
				if (o.length) {
					App.controls.page_reloader.add(id);
					o.addClass('listing__item-outdated').removeClass('listing__item-draggable');
				}
				break;
		}
	},

	helper_invalidate_relations: function (ids) {
		if (ids == null) return;

		ids.forEach(function (id_related) {
			App.task_view_cache.invalidate_relations_by_id(id_related);
		});
	},

	// debounce to prevent duplication on `descr` + `attach`
	helper_reload_description: App.helper.debounce(function (id) {
		if (!App.object_state.active_tab) { // already received
			let o = App.task_view_cache.get_all().find('#obj-task-view' + id);
			if (o.length) {
				o.find('.taskView__group-descr').find('.taskView__group__content').load(App.helper.endpoint.task(id) + '?' + App.actions.get('task_data_reload:show') + '&field=descr');
			}
		}
		let chat_o = App.task_view_cache.get_all().find('#obj-task-view' + id).find('.taskView__intro-description');
		if (chat_o.length) {
			chat_o.load(App.helper.endpoint.task(id) + '?' + App.actions.get('task_data_reload:show') + '&field=descr');
		}
	}),

	helper_class_to_subscribers: function(className) {
		let classNames = className.trim().split(' ');
		let ids_user = [];
		classNames.forEach(classItem => {
			if (/^s\d+$/.test(classItem)) {
				ids_user.push(+classItem.substring(1));
			}
		});
		return ids_user;
	}
}

;App.object_state.user = {
	// TODO: websocket + DB user_log

	add: function(id, data) {
		this.helper_invalidate_users();

		// треба бути обережним якщо вкладені модалки (наприклад, project_create + user_add)
		// if (App.current_page.where === 'account_members') App.page.helper_update(id, 'add'); // TODO: знайди зайвий редірект на /users/ при додавані з сторінки members
	},

	delete: function(id, data) {
		if (id === App.me.id) {
			App.core.reload();
		} else {
			this.helper_invalidate_users();
			// // TODO: перерисовать все списки юзеров, фильтра и т.п.
			// if (App.page.where() === 'users') App.core.reload();
			// if (App.current_page.where === 'account_members') App.page.helper_update(id, 'delete');
		}
	},

	update: function(id, data) {

		let ava = App.task_view_cache.get_all().add('body').find('.av_sm[data-user=' + id + ']');
		ava.prev().filter('.ico_place').toggleClass('ico_ava', data.icon !== '').html(data.icon); // @see replace_avatars_with_icons
		ava.replaceWith(data.avatar)

		ava = App.task_view_cache.get_all().add('body').find('.av_nm[data-user=' + id + ']');
		ava.replaceWith(data.avatar_big);

		let attr = $(data.avatar_big).attr('data-preview');
		if ( typeof attr !== 'undefined' && attr !== false ) {
			ava = App.task_view_cache.get_all().add('body').find('.img_big .av_nm[data-user=' + id + ']');
			setTimeout(function() { ava.attr('src', attr); }, 5);
		}

		if (id in App.team) {
			App.team[id].name = App.format.user_name(data);
			App.team[id].avatar = data.avatar;
			App.team[id].icon = data.icon;
			const old_email = App.team[id].email;
			App.team[id].email = data.email;
			if (old_email) {
				App.team[id].extra = App.team[id].extra.replace(old_email, data.email);
			}
		}

		App.chat_view.on_user_update(id, data);

		this.helper_invalidate_users();
	},

	topic_status: function(id, data) {
		App.components.user_topic_status?.helper_update_by_object(id, data);
	},

	team: function(id, data) {
		if (id === App.me.id && !App.profile.is_shown) {
			App.core.reload();
		} else {
			this.helper_invalidate_users();
		}
	},

	role: function(id, data) {
		if (id === App.me.id && !App.profile.is_shown) {
			App.core.reload();
		} else {
			this.helper_invalidate_users();
		}
	},

	owner: function(id, data) {
		App.controls.account_phone_update.show_popup = id === App.me.id && +data.is_owner === 1;

		if (id === App.me.id && !App.profile.is_shown) {
			App.core.reload();
		} else {
			this.helper_invalidate_users();
		}
	},

	helper_invalidate_users: function () {
		// TODO: перерисовать все списки юзеров, фильтра и т.п.
		App.mymenu.invalidate_window('chats');
		App.mymenu.invalidate_window('users');
		App.mymenu.invalidate_window('users_star');

		if (App.current_page.page === 'users' || App.current_page.where === 'account_members') {
			if (App.object_state.active_tab) App.core.reload();
			else App.controls.page_reloader.users_changed();
		}
	},
}

;App.object_state.user_group = {

	helper_invalidate_after_update: function() {
		App.mymenu.invalidate_window('chats');
		App.mymenu.invalidate_window('users');
		App.mymenu.invalidate_window('users_star');

		switch (App.page.where()) {
			case 'users':
				App.page.process_search();
				break;
		}
	},

	update: function(id, data) {
		this.helper_invalidate_after_update();
	},
}

;App.object_state.user_group_sub = {

	update: function(id, data) {
		App.object_state.user_group.helper_invalidate_after_update();
	},
}

;App.object_state.view = {
	order: function (id, data) {
		if (!App.controls.view_list.is_shown(data.id_project, data.page_group)) return;

		if (data.reload) App.controls.view_list.reload();
	},

	name: function (id, data) {
		const item = App.controls.view_list.get_item(id);
		if (!item.length) return;

		const menu_item = App.controls.view_list.get_menu_item(id);
		if (!menu_item.length) return;

		const is_editing = App.controls.view_list.edit.view_id && App.controls.view_list.edit.view_id == id;
		if (is_editing) {
			App.controls.view_list.edit.pending_name = data.name;
			return;
		}

		const old_name = item.find('.in').text();
		if (old_name != data.name) {

			item.find('.in').text(data.name);
			menu_item.find('.in').text(data.name);
			App.controls.view_list.onresize();

			item.animate_css('blink');
			menu_item.animate_css('blink');
		}
	},

	add: function (id, data) {
		if (!App.controls.view_list.is_shown(data.id_project, data.page_group)) return;

		const template_data = {...data, id};

		const item = App.helper.template.fill('view_item', template_data);
		const menu_item = App.helper.template.fill('view_menu_item', template_data);

		const mo = +data.manual_order;
		let added = false;
		if (mo) {
			App.controls.view_list.obj_window.find('.viewsList__item').each(function (_, el) {
				const $el = $(el);
				const this_mo = +$el.attr('data-manual-order');

				if (mo <= this_mo) {
					added = true;
					$el.before(item);
					const this_id = +$el.attr('data-id');
					if (this_id) $('#viewsMoreMenu .menu__group-searchable .menu__items-row[data-id="'+this_id+'"]').before(menu_item);
					return false; // break
				}
			});
		}
		if (!added) {
			App.controls.view_list.obj_window.find('.viewsList__item-more').before(item);
			$('#viewsMoreMenu .menu__group-searchable').append(menu_item);
		}

		App.controls.view_list.onresize();
	},

	delete: function (id, data) {
		if (!App.controls.view_list.is_shown(data.id_project, data.page_group)) return;

		const item = App.controls.view_list.get_item(id);
		if (!item.length) return;

		const menu_items_row = App.controls.view_list.get_menu_items_row(id);
		if (!menu_items_row.length) return;

		const go_to_primary = item.hasClass('viewsList__item-active');

		item.remove();
		menu_items_row.remove();
		App.controls.view_list.onresize();

		if (!App.controls.view_list.obj_window.find('.viewsList__item-plus').length && App.controls.view_list.obj_window.find('.viewsList__item[data-id], .viewsList__item[data-tmp-id]').length < 2) {
			App.controls.view_list.obj_window.addClass('viewsList_hidden');
		}

		if (go_to_primary) {
			App.controls.view_list.obj_window.find('.viewsList__item').eq(0).trigger('click');
			return;
		}

		if (data.reload) App.controls.view_list.reload();
	},

	save_filter: function (id, data) {
		const item = App.controls.view_list.get_item(id);
		if (!item.length) return;

		const menu_item = App.controls.view_list.get_menu_item(id);
		if (!menu_item.length) return;

		const is_active = item.hasClass('viewsList__item-active');

		item.toggleClass('viewsList__item-updated', !!data.is_updated);
		menu_item.toggleClass('menu__item-view-updated', !!data.is_updated);

		App.controls.view_list.onresize();

		if (App.object_state.active_tab) {}
		else if (is_active) App.controls.views.reload();
	},

	save_filter_advanced: function (id, data) {
		const item = App.controls.view_list.get_item(id);
		if (!item.length) return;

		const menu_item = App.controls.view_list.get_menu_item(id);
		if (!menu_item.length) return;

		const is_active = item.hasClass('viewsList__item-active');

		item.toggleClass('viewsList__item-updated', !!data.is_updated);
		menu_item.toggleClass('menu__item-view-updated', !!data.is_updated);

		App.controls.view_list.onresize();

		if (App.object_state.active_tab) {}
		else if (is_active) App.controls.views.reload();
	},

	save_order: function (id, data) {
		const item = App.controls.view_list.get_item(id);
		if (!item.length) return;

		const menu_item = App.controls.view_list.get_menu_item(id);
		if (!menu_item.length) return;

		const is_active = item.hasClass('viewsList__item-active');

		item.toggleClass('viewsList__item-updated', !!data.is_updated);
		menu_item.toggleClass('menu__item-view-updated', !!data.is_updated);

		App.controls.view_list.onresize();

		if (App.object_state.active_tab) {}
		else if (is_active) App.controls.views.reload();
	},

	set_option: function (id, data) {
		const item = App.controls.view_list.get_item(id);
		if (!item.length) return;

		const menu_item = App.controls.view_list.get_menu_item(id);
		if (!menu_item.length) return;

		const is_active = item.hasClass('viewsList__item-active');

		item.toggleClass('viewsList__item-updated', !!data.is_updated);
		menu_item.toggleClass('menu__item-view-updated', !!data.is_updated);

		App.controls.view_list.onresize();

		if (App.object_state.active_tab) {}
		else if (is_active) App.controls.views.reload();
	},

	save: function (id, data) {
		const item = App.controls.view_list.get_item(id);
		if (!item.length) return;

		const menu_item = App.controls.view_list.get_menu_item(id);
		if (!menu_item.length) return;

		const is_active = item.hasClass('viewsList__item-active');

		item.removeClass('viewsList__item-updated').find('ws-icon[name=shared]').parent().remove();
		menu_item.removeClass('menu__item-view-updated');

		App.controls.view_list.onresize();

		if (App.object_state.active_tab) {}
		else if (is_active && data.is_new) App.controls.views.reload();
	},

	reset: function (id, data) {
		const item = App.controls.view_list.get_item(id);
		if (!item.length) return;

		const menu_item = App.controls.view_list.get_menu_item(id);
		if (!menu_item.length) return;

		const is_active = item.hasClass('viewsList__item-active');

		item.removeClass('viewsList__item-updated');
		menu_item.removeClass('menu__item-view-updated');

		App.controls.view_list.onresize();

		if (is_active) App.controls.views.reload();
	},
}

;App.object_state.view_tmp = {
	delete: function(id, data) {
		const item = App.controls.view_list.get_tmp_item(id);
		if (!item.length) return;

		item.remove();
		App.controls.view_list.onresize();

		let back = App.controls.view_list.obj_window.find('.viewsList__item').eq(0);
		const after = App.controls.view_list.tmp.insert_after;
		App.controls.view_list.tmp.insert_after = null;
		if (after) {
			const found = App.controls.view_list.obj_window.find('.viewsList__item[data-id="' + after + '"], .viewsList__item[data-tmp-id="' + after + '"]');
			if (found.length) back = found;
		}
		back.trigger('click');
	},
}
